import React, { useState, useEffect, useRef } from 'react';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import Container from 'react-bootstrap/Container';
import NavDropdown from 'react-bootstrap/NavDropdown'
import './styles.css';
import logo from '../../assets/imgs/logo_kapplan_energy.png';
import logo_fundo_preto from '../../assets/imgs/logo_fundo_preto.png';
import Modal from "react-modal";
import CallIcon from '@mui/icons-material/Call';
import PersonIcon from '@mui/icons-material/Person';

import SettingsIcon from '@mui/icons-material/Settings';
import { IconButton } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

import icone_subestacao from '../../assets/imgs/icone_subestacao.png';
import icone_casa from '../../assets/imgs/icone_casa.png';
import icone_loja from '../../assets/imgs/icone_loja.png';
import DescriptionIcon from '@mui/icons-material/Description';
import { Rnd } from "react-rnd";
import PhoneIcon from '@mui/icons-material/Phone';

import BuildIcon from '@mui/icons-material/Build'; // Ícone para representar "Área Técnica"
import Tooltip from '@mui/material/Tooltip';


import Grid from '@material-ui/core/Grid';
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import NotificationsIcon from '@material-ui/icons/Notifications';
import Brightness4 from '@material-ui/icons/Brightness4';
import Brightness7 from '@material-ui/icons/Brightness7';
import mini_icone_informacao from '../../assets/imgs/mini_icone_informacao.png';
import Cookies from 'js-cookie';
import { Box } from "@mui/material";
import TextField from '@material-ui/core/TextField';
import { useLocation } from 'react-router-dom';
import Draggable from "react-draggable";
import FolderIcon from '@mui/icons-material/Folder';

import Divider from '@mui/material/Divider';



import api from '../../services/api';
import Typography from '@material-ui/core/Typography';
import { Button } from "@material-ui/core";
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { useHistory } from "react-router-dom";
import {
  DialogActions,
  DialogContentText,
} from "@mui/material";
import {

  Link

} from "react-router-dom";
import miniatura_pdf from '../../assets/imgs/miniatura_pdf.png';
import office from '../../assets/imgs/office.png';
import CloseIcon from '@mui/icons-material/Close';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Skeleton from '@material-ui/lab/Skeleton';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { Select, MenuItem, InputLabel, FormControl } from '@mui/material';



const customStyles = {
  content: {
    top: "0", // Alinha ao topo
    left: "0", // Alinha à esquerda
    right: "auto",
    bottom: "0", // Ocupa toda a altura
    margin: "0", // Remove margens
    transform: "none", // Nenhuma transformação necessária
    width: "30%", // Ocupa 30% da largura disponível
    height: "100%", // Ocupa 100% da altura da tela
    zIndex: 9999, // Sobrepõe todas as telas
    backgroundColor: "white", // Fundo branco para o modal
    borderRadius: "0 8px 8px 0", // Bordas arredondadas apenas no lado direito
    boxShadow: "4px 0 10px rgba(0, 0, 0, 0.2)", // Sombra para dar destaque ao modal
    pointerEvents: "auto",
  },
  overlay: {
    zIndex: 9998,
    backgroundColor: "rgba(0, 0, 0, 0.0)",
    pointerEvents: "none", // Mantém clique liberado no fundo
  },
};

const customStylesMobile = {
  content: {
    top: "0", // Alinha ao topo
    left: "0", // Alinha à esquerda
    right: "auto",
    bottom: "0", // Ocupa toda a altura
    margin: "0", // Remove margens
    transform: "none", // Nenhuma transformação necessária
    width: "100%", // Ocupa 30% da largura disponível
    height: "100%", // Ocupa 100% da altura da tela
    zIndex: 9999, // Sobrepõe todas as telas
    backgroundColor: "white", // Fundo branco para o modal
    borderRadius: "0 8px 8px 0", // Bordas arredondadas apenas no lado direito
    boxShadow: "4px 0 10px rgba(0, 0, 0, 0.2)", // Sombra para dar destaque ao modal
    pointerEvents: "auto",
  },
  overlay: {
    zIndex: 9998,
    backgroundColor: "rgba(0, 0, 0, 0.0)",
    pointerEvents: "none", // Mantém clique liberado no fundo
  },
};

const NavegadorGestao = (props) => {


  const [urlChamada, setUrlChamada] = useState("");

  const [isOpen, setIsOpen] = useState(false);

  const openModal = (ramal) => {
    setUrlChamada("https://gruporosinetos.com/call/softphone.html?wp_serveraddress=gruporosinetos.com:6050&wp_username=webrtc&wp_password=1234&wp_callto=" + ramal + "&wp_autoaction=1");
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
    setUrlChamada("");
  };

  const iframeRef = useRef(null);
  const [hasLoaded, setHasLoaded] = useState(false);
  const [retries, setRetries] = useState(0);

  const MAX_RETRIES = 7; // Número máximo de tentativas de recarregar o iframe




  const checkIframeContent = () => {
    setTimeout(() => {
      try {
        const iframeWindow = iframeRef.current?.contentWindow;

        if (!iframeWindow) {
          console.warn("Não foi possível acessar o conteúdo do iframe.");
          return;
        }

        const logs = iframeWindow.document.body.innerText;


        // Verifica mensagens indicativas de carregamento completo
        //alert(logs);
        const isLoaded =
          logs.includes("menu") || logs.includes("Menu") ||
          logs.includes("GetBrowserVersion") ||
          logs.includes("About:");

        if (isLoaded) {
          setHasLoaded(true);
          console.log("Página carregada com sucesso no iframe!");
        } else if (retries < MAX_RETRIES) {
          console.warn(`Tentativa ${retries + 1}: Página não carregou completamente, recarregando iframe...`);
          setRetries(retries + 1);
          iframeRef.current.src += ""; // Recarrega o iframe
        } else {
          console.error("Número máximo de tentativas atingido. Não foi possível carregar o iframe.");
        }
      } catch (err) {
        console.error("Erro ao verificar conteúdo do iframe:", err);
      }
    }, 2000); // Delay de 1 segundo para aguardar o carregamento
  };

  useEffect(() => {
    if (!isOpen) {
      setHasLoaded(false); // Reseta o estado ao fechar
      setRetries(0); // Reseta o número de tentativas
    }
  }, [isOpen]);


  // ESTADOS
  const [openBalaoTarefas, setOpenBalaoTarefas] = useState(false);
  const [compactadoTarefas, setCompactadoTarefas] = useState(true);
  const [limiar, setLimiar] = useState(900);

  const [openBalaoNotificacao, setOpenBalaoNotificacao] = useState(false);
  const handleOpenBalaoNotificacao = () => {

    setOpenBalaoNotificacao(true);
  };



  const handleCloseBalaoNotificacao = () => {
    setOpenBalaoNotificacao(false);
  };

  const [show, setShow] = useState(false);


  const [openRondaVirtualEmAndamento, setOpenRondaVirtualEmAndamento] = useState(false);
  const [rondaVirtualEmAndamento, setRondaVirtualEmAndamento] = useState(null);

  const location = useLocation();

  const isMonitoramento = location.pathname.includes('/tecnica/monitoramento');

  const [limites, setLimites] = useState(null);
  const [descontos, setDescontos] = useState(null);

  const [navBar, setNavbar] = useState(false);
  const [loading, setLoading] = useState(true);
  const [tarefas, setTarefas] = useState([]);
  const [projetos, setProjetos] = useState([]);

  const [open, setOpen] = React.useState(true);
  const [width, setWidth] = useState(0);
  const [larguraOriginal, setLarguraOriginal] = useState(0);
  const [alertOpen, setAlertOpen] = useState(false);
  const [tarefaEmVista, setTarefaEmvista] = useState();
  const regra = Cookies.get('regra') || '';
  const [isCliente, setIsCliente] = useState(() => {
    return regra.toUpperCase().includes("CLIENTE") || regra.toUpperCase().includes("ASSOC_") || regra.toUpperCase().includes("COLABORADOR");
  });
  const [loadingCliente, setLoadingCliente] = useState(() => {
    return !(regra.toUpperCase().includes("CLIENTE") || regra.toUpperCase().includes("ASSOC_") || regra.toUpperCase().includes("COLABORADOR"));
  });

  useEffect(() => {
    async function checkCliente() {
      if (!loadingCliente) return;
      try {
        const idUsuario = Cookies.get('id_usuario');
        const token = Cookies.get('token');
        if (!idUsuario || !token) {
           setLoadingCliente(false);
           return;
        }
        const headers = { Authorization: 'Bearer ' + token };
        const response = await api.get(`/v1/protected/user/retornardadosusuario/${idUsuario}`, { headers });
        if (response.data && response.data.cliente && response.data.cliente.id_cliente) {
           setIsCliente(true);
        }
      } catch (error) {
        console.log("Erro ao checar dados do cliente", error);
      } finally {
        setLoadingCliente(false);
      }
    }
    checkCliente();
  }, [loadingCliente]);

  // ESTADOS PARA NOVO PROJETO E PROPOSTA RAPIDO
  const [openModalNovoProjeto, setOpenModalNovoProjeto] = useState(false);
  const [loadingModalProjetos, setLoadingModalProjetos] = useState(false);
  const [listaClientesModal, setListaClientesModal] = useState([]);
  const [clienteSelecionadoModal, setClienteSelecionadoModal] = useState(null);
  const [instalacaoSelecionadaModal, setInstalacaoSelecionadaModal] = useState(null);
  const [nomeProjetoModal, setNomeProjetoModal] = useState('');
  const [descricaoProjetoModal, setDescricaoProjetoModal] = useState('');
  const [descricaoPropostaModal, setDescricaoPropostaModal] = useState('');

  // ESTADOS PARA NOVO CLIENTE DENTRO DO MODAL
  const [isNovoCliente, setIsNovoCliente] = useState(false);
  const [tipoPessoaModal, setTipoPessoaModal] = useState(0); // 0: Fisica, 1: Juridica
  const [cnpjCpfModal, setCnpjCpfModal] = useState('');
  const [nomeRazaoModal, setNomeRazaoModal] = useState('');
  const [sobrenomeFantasiaModal, setSobrenomeFantasiaModal] = useState('');
  const [emailClienteModal, setEmailClienteModal] = useState('');

  // Endereço do novo cliente
  const [enderecoModal, setEnderecoModal] = useState({
    logradouro: "",
    numero: "",
    bairro: "",
    complemento: "",
    cidade: "",
    estado: "",
    cep: "",
    latitude: "",
    longitude: "",
  });

  const estadosBrasil = [
    'Acre', 'Alagoas', 'Amapá', 'Amazonas', 'Bahia', 'Ceará', 'Distrito Federal',
    'Espírito Santo', 'Goiás', 'Maranhão', 'Mato Grosso', 'Mato Grosso do Sul',
    'Minas Gerais', 'Pará', 'Paraíba', 'Paraná', 'Pernambuco', 'Piauí', 'Rio de Janeiro',
    'Rio Grande do Norte', 'Rio Grande do Sul', 'Rondônia', 'Roraima', 'Santa Catarina',
    'São Paulo', 'Sergipe', 'Tocantins'
  ];

  // ============================
  // DARK MODE STATE & COOKIE
  // ============================
  const [darkMode, setDarkMode] = useState(() => {
    const saved = Cookies.get('darkMode');
    return saved === 'true';
  });

  const toggleDarkMode = () => {
    const newValue = !darkMode;
    setDarkMode(newValue);
    Cookies.set('darkMode', String(newValue), { expires: 365, path: '/' });
    window.dispatchEvent(new Event('darkModeChanged'));
  };

  useEffect(() => {
    const handleThemeChange = () => {
      const saved = Cookies.get('darkMode');
      setDarkMode(saved === 'true');
    };
    window.addEventListener('darkModeChanged', handleThemeChange);
    return () => window.removeEventListener('darkModeChanged', handleThemeChange);
  }, []);

  // Theme tokens
  const effectiveDarkMode = (larguraOriginal < limiar) || darkMode;

  // Enforce dark mode on mobile
  useEffect(() => {
    if (larguraOriginal > 0 && larguraOriginal < limiar && !darkMode) {
      setDarkMode(true);
      Cookies.set('darkMode', 'true', { expires: 365 });
      window.dispatchEvent(new Event('darkModeChanged'));
    }
  }, [larguraOriginal, limiar, darkMode]);

  // Theme tokens
  const theme = {
    bg: effectiveDarkMode ? "#252525" : "#e9eff3",
    paper: effectiveDarkMode ? "#2e2e2e" : "#f5f8fa",
    text: effectiveDarkMode ? "#ffffff" : "#1a1a1a",
    textSecondary: effectiveDarkMode ? "#aaaaaa" : "#5a6a7a",
    border: effectiveDarkMode ? "#444444" : "#d1d9e0",
    navbarBg: effectiveDarkMode ? "#252525" : "#ffffff",
    navbarVariant: effectiveDarkMode ? "dark" : "light",
  };

  const [oSOC, setOSOC] = useState();

  const [alertOpen2, setAlertOpen2] = useState(false);


  const history = useHistory();

  const [justificativa, setJustificativa] = useState(false);
  const [mensagemJustificativa, setMensagemJustificativa] = useState(null);

  const [pesquisarOc, setPesquisarOc] = useState(false);

  const [OcPendente, setOcPendente] = useState(null);

  const [openBalaoOc, setOpenBalaoOc] = useState(false);
  const handleOpenBalaoOc = () => {

    setOpenBalaoOc(true);
  };


  const [compactado, setCompactado] = useState(true);

  const handleCloseBalaoOc = () => {
    setOpenBalaoOc(false);
  };




  const [mostrarCampoPulo, setMostrarCampoPulo] = useState(false);
  const [mensagemPulo, setMensagemPulo] = useState("");


  const handleJustificativa = () => {
    setMensagemJustificativa(null);
    setJustificativa(true);
  }

  const [openBalao, setOpenBalao] = useState(false);
  const handleOpenBalao = () => {

    setOpenBalao(true);
  };



  const handleCloseBalao = () => {
    setMensagemJustificativa(null);
    setJustificativa(false);
    setOpenBalao(false);
  };

  const [touchStartY, setTouchStartY] = useState(null);
  const [navbarExpanded, setNavbarExpanded] = useState(false);

  const handleTouchStart = (e) => {
    setTouchStartY(e.touches[0].clientY);
  };

  const handleTouchEnd = (e) => {
    if (touchStartY === null) return;
    const touchEndY = e.changedTouches[0].clientY;
    const distance = touchEndY - touchStartY;

    // Se deslizou para baixo mais de 50px e está no mobile
    if (distance > 50 && larguraOriginal < limiar) {
      setNavbarExpanded(true);
    }
    setTouchStartY(null);
  };

  const handleIrParaGestaoRondaVirtual = () => {
    history.push({
      pathname: "/gestao/operacional/rondavirtual/gerenciar/" + rondaVirtualEmAndamento.id_ronda_virtual,
    })
  };

  async function listarLimites() {
    try {
      const id_usuario = Cookies.get('id_usuario');
      const token = Cookies.get('token');

      const headers = {
        'Authorization': 'Bearer ' + token
      };

      // Pega a data atual
      const hoje = new Date();
      const mes = hoje.getMonth() + 1; // getMonth retorna 0-11, por isso +1
      const ano = hoje.getFullYear();

      await api.get(
        `v1/protected/user/retornardadoslimite/${id_usuario}/${mes}/${ano}`,
        { headers }
      ).then(function (response) {
        setLimites(response.data);
      });

    } catch (_err) {
      console.log("Erro ao listar limites: " + _err);
    }
  }



  const [ramais, setRamais] = useState([]);

  async function listarRamais() {
    try {
      const id_usuario = Cookies.get('id_usuario');
      const token = Cookies.get('token');

      const headers = {
        'Authorization': 'Bearer ' + token
      };


      await api.get(
        `v1/protected/equipamentos/telefones`,
        { headers }
      ).then(function (response) {
        setRamais(response.data);
      });

    } catch (_err) {
      console.log("Erro ao listar limites: " + _err);
    }
  }

  const posicaoPadrao = {
    x: Cookies.get("pos_x_tarefas")
      ? parseInt(Cookies.get("pos_x_tarefas"))
      : window.innerWidth - 380,
    y: Cookies.get("pos_y_tarefas")
      ? parseInt(Cookies.get("pos_y_tarefas"))
      : 10,
  };

  const [posicao, setPosicao] = useState(posicaoPadrao);

  const [size, setSize] = useState({
    width: compactadoTarefas ? 50 : 350,
    height: compactadoTarefas ? 50 : "auto",
  });

  function toggleCompactado() {
    const novo = !compactadoTarefas;
    setCompactadoTarefas(novo);

    setSize({
      width: novo ? 50 : 350,
      height: novo ? 50 : "auto",
    });
  }


  async function listarDescontos() {
    try {
      const id_usuario = Cookies.get('id_usuario');
      const token = Cookies.get('token');

      const headers = {
        'Authorization': 'Bearer ' + token
      };

      // Pega a data atual
      const hoje = new Date();
      const mes = hoje.getMonth() + 1; // getMonth retorna 0-11, por isso +1
      const ano = hoje.getFullYear();

      await api.get(
        `v1/protected/user/retornardadosdescontos/${id_usuario}/${mes}/${ano}`,
        { headers }
      ).then(function (response) {
        setDescontos(response.data);
      });

    } catch (_err) {
      console.log("Erro ao listar Descontos: " + _err);
    }
  }

  const handleOpenModalNovoProjeto = async () => {
    setOpenModalNovoProjeto(true);
    setNavbarExpanded(false); // Fecha o menu se estiver no mobile
    setLoadingModalProjetos(true);
    try {
      const headers = { 'Authorization': 'Bearer ' + Cookies.get("token") };
      const response = await api.get("v1/protected/clientes/listarTodos", { headers });
      setListaClientesModal(response.data);
    } catch (err) {
      console.log("Erro ao listar clientes para o modal: ", err);
    } finally {
      setLoadingModalProjetos(false);
    }
  };

  const handleCloseModalNovoProjeto = () => {
    setOpenModalNovoProjeto(false);
    resetCamposModal();
  };

  const resetCamposModal = () => {
    setClienteSelecionadoModal(null);
    setInstalacaoSelecionadaModal(null);
    setNomeProjetoModal('');
    setDescricaoProjetoModal('');
    setDescricaoPropostaModal('');
    setIsNovoCliente(false);
    setCnpjCpfModal('');
    setNomeRazaoModal('');
    setSobrenomeFantasiaModal('');
    setEmailClienteModal('');
    setEnderecoModal({
      logradouro: "", numero: "", bairro: "", complemento: "",
      cidade: "", estado: "", cep: "", latitude: "", longitude: ""
    });
  };

  const random6Digit = () => Math.floor(100000 + Math.random() * 900000).toString();

  async function handleSalvarNovoProjetoRapido() {
    setLoadingModalProjetos(true);
    try {
      const headers = { 'Authorization': 'Bearer ' + Cookies.get("token") };
      let idClienteFinal = clienteSelecionadoModal?.id_cliente;
      let idInstalacaoFinal = instalacaoSelecionadaModal?.id_instalacao;

      // 1. Criar Cliente e Instalação se for novo
      if (isNovoCliente) {
        const payloadCliente = {
          tipo_cliente: tipoPessoaModal,
          nome: tipoPessoaModal === 0 ? nomeRazaoModal : null,
          sobrenome: tipoPessoaModal === 0 ? sobrenomeFantasiaModal : null,
          razao_social: tipoPessoaModal === 1 ? nomeRazaoModal : null,
          nome_fantasia: tipoPessoaModal === 1 ? sobrenomeFantasiaModal : null,
          cpf: tipoPessoaModal === 0 ? cnpjCpfModal : null,
          cnpj: tipoPessoaModal === 1 ? cnpjCpfModal : null,
          email: emailClienteModal,
          ...enderecoModal
        };

        const resCliente = await api.post('/v1/protected/clientes/cadastrar', payloadCliente, { headers });
        if (!resCliente.data) throw new Error("Falha ao cadastrar cliente");
        idClienteFinal = resCliente.data.id_cliente;

        // Criar Instalação automática
        const payloadInstalacao = {
          ...payloadCliente,
          identificador_integrador: random6Digit()
        };
        const resInstalacao = await api.post('/v1/protected/unidades/cadastrar', payloadInstalacao, { headers });
        if (!resInstalacao.data) throw new Error("Falha ao cadastrar instalação");
        idInstalacaoFinal = resInstalacao.data.id_instalacao;
      }

      if (!idClienteFinal || !idInstalacaoFinal) {
        alert("Selecione um cliente e instalação válidos.");
        return;
      }

      // 2. Criar Projeto
      const formDataProjeto = new FormData();
      formDataProjeto.append('nome_projeto', nomeProjetoModal);
      formDataProjeto.append('descricao_projeto', descricaoProjetoModal);
      formDataProjeto.append('cliente.id_cliente', idClienteFinal);
      formDataProjeto.append('instalacao.id_instalacao', idInstalacaoFinal);
      formDataProjeto.append('usuario_criador.id_usuario', Cookies.get('id_usuario'));

      const resProjeto = await api.post('/v1/protected/projetos/cadastrar', formDataProjeto, { headers });
      if (!resProjeto.data) throw new Error("Falha ao cadastrar projeto");
      const idProjeto = resProjeto.data.id_projeto;

      // 3. Criar Primeira Proposta
      const formDataProposta = new FormData();
      formDataProposta.append('descricao_proposta', descricaoPropostaModal);
      formDataProposta.append('status_proposta', 0); // Aberta
      formDataProposta.append('usuario_criador.id_usuario', Cookies.get('id_usuario'));
      formDataProposta.append('itensRaw', '[]'); // Vazio inicialmente

      const resProposta = await api.post(`/v1/protected/projetos/propostas/cadastrar/${idProjeto}`, formDataProposta, { headers });
      if (!resProposta.data) throw new Error("Falha ao cadastrar proposta");
      const idProposta = resProposta.data.id_proposta;

      alert("Projeto e Proposta criados com sucesso!");
      handleCloseModalNovoProjeto();
      
      // Redirecionar para edição da proposta
      history.push(`/gestao/administracao/projetos/editarprojeto/${idProjeto}/propostas/editarproposta/${idProposta}/1/${idInstalacaoFinal}/0`);

    } catch (err) {
      console.error(err);
      alert("Erro ao realizar cadastro completo: " + err.message);
    } finally {
      setLoadingModalProjetos(false);
    }
  }

  const handleCnpjModal = async (cnpj) => {
    let cnpjSemFormato = cnpj.replace(/\D/g, '').slice(0, 14);
    setCnpjCpfModal(cnpjSemFormato);
    if (cnpjSemFormato.length === 14) {
      try {
        const response = await api.get('https://brasilapi.com.br/api/cnpj/v1/' + cnpjSemFormato);
        setNomeRazaoModal(response.data.razao_social);
        setSobrenomeFantasiaModal(response.data.razao_social);
        setEnderecoModal(prev => ({
          ...prev,
          logradouro: response.data.logradouro,
          bairro: response.data.bairro,
          estado: response.data.uf,
          numero: response.data.numero,
          cep: response.data.cep,
          cidade: response.data.municipio,
          complemento: response.data.complemento
        }));
      } catch (err) { console.log(err); }
    }
  };





  async function handleBalaoOk() {
    //verificar se a ronda virtual ainda esta pendente
    try {


      console.log("Vizualizar tarefa chamado");
      const id_usuario = Cookies.get('id_usuario');


      var url = "v1/protected/rondavirtual/verificarpendente/" + parseInt(rondaVirtualPendente.id_ronda_virtual, 10);
      //console.log("Url: " + url);
      await api.get(url).then(function (response) {
        // alert(response.data);
        if (response.data === "ronda_nula") {
          setRondaVirtualPendente(null);
          handleCloseBalao();
          alert("Ronda não mais listada no sistema!");
        } else if (response.data === "disponivel") {
          //assumir
          const token = Cookies.get('token');
          const headers = {
            'Authorization': 'Bearer ' + token
          }
          const cadastro = {
            usuario_executor: { id_usuario: Cookies.get("id_usuario") },
          }
          api.put("/v1/protected/rondavirtual/assumirrondavirtual/" + rondaVirtualPendente.id_ronda_virtual + "/" + Cookies.get("id_usuario"), cadastro, {
            headers: headers
          }).then(function (response) {
            if (parseInt(response.data.usuario_executor.id_usuario) === parseInt(Cookies.get("id_usuario"), 10)) {
              setRondaVirtualPendente(null);
              handleCloseBalao();
              alert("Ronda Virtual assumida por você");
              history.push({
                pathname: "/gestao/operacional/rondavirtual/gerenciar/" + response.data.id_ronda_virtual,
              })
            } else {
              setRondaVirtualPendente(null);
              handleCloseBalao();
              alert("Erro, consulte o administrador");
            }
          });

        } else {
          setRondaVirtualPendente(null);
          handleCloseBalao();
          alert("Usuário " + response.data + " já assumiu a execução dessa ronda virtual");
        }
      });


    } catch (_err) {
      console.log("Erro ao vizualizar acao, err: " + _err);

    }
  };


  async function handleFinalizarJustificativa() {
    //verificar se a ronda virtual ainda esta pendente
    try {
      if (mensagemJustificativa.length < 10) {
        alert("Detalhe sua justificativa!");
        return;
      }

      const id_usuario = Cookies.get('id_usuario');


      var url = "v1/protected/rondavirtual/verificarpendente/" + parseInt(rondaVirtualPendente.id_ronda_virtual, 10);
      //console.log("Url: " + url);
      await api.get(url).then(function (response) {
        // alert(response.data);
        if (response.data === "ronda_nula") {
          setRondaVirtualPendente(null);
          handleCloseBalao();
          alert("Ronda não mais listada no sistema!");
        } else if (response.data === "disponivel") {
          //cancelar
          const token = Cookies.get('token');
          const headers = {
            'Authorization': 'Bearer ' + token
          }
          const cadastro = {
            id_usuario: Cookies.get("id_usuario"),
            id_ronda_virtual: rondaVirtualPendente.id_ronda_virtual,
            mensagem: mensagemJustificativa,
          }
          api.put("/v1/protected/rondavirtual/cancelarrondavirtual", cadastro, {
            headers: headers
          }).then(function (response) {

            if (response.data) {
              setRondaVirtualPendente(null);
              handleCloseBalao();
              alert("Justificativa Registrada!");
            } else {
              alert("Erro inesperado, consulte o administrador!");
            }

          });

        } else {
          setRondaVirtualPendente(null);
          handleCloseBalao();
          alert("Usuário " + response.data + " já assumiu a execução dessa ronda virtual");
        }
      });


    } catch (_err) {
      console.log("Erro ao vizualizar acao, err: " + _err);

    }
  };










  async function handlePulo() {
    //verificar se a ronda virtual ainda esta pendente
    try {
      if (mensagemPulo.length < 10) {
        alert("Detalhe sua justificativa!");
        return;
      }



      const id_usuario = Cookies.get('id_usuario');


      const cadastro = {
        id_usuario: id_usuario,
        id_ordem_compra: OcPendente.idOrdemCompra,
        id_pre_cotacao: OcPendente.idPreCotacao,
        mensagem: mensagemPulo,
      }


      var url = "v1/protected/ordensdecompras/pular";
      //console.log("Url: " + url);
      await api.post(url, cadastro).then(function (response) {
        if (response.data) {
          alert("A Solicitação foi adiada para mais tarde!");
        }
      });


    } catch (_err) {
      console.log("Erro ao pular acao, err: " + _err);

    }
    setMensagemPulo("");
    setOpenBalaoOc(false);
    setMostrarCampoPulo(false);
    setOcPendente(null);

  };



  // const [larguraOriginal, setLarguraOriginal] = useState(0); // Movido para o topo

  function checkDimenssoes() {
    var largura = window.innerWidth
      || document.documentElement.clientWidth
      || document.body.clientWidth;

    setWidth(largura);
    setLarguraOriginal(largura);


  }

  window.addEventListener('resize', function (event) {
    checkDimenssoes();
  });

  window.addEventListener('scroll', function (event) {
    changeBackground();
  });


  const changeBackground = () => {
    //console.log(window.scrollY)
    if (window.scrollY >= 200) {
      setNavbar(true)
    } else {
      setNavbar(false)
    }
  }




  const [dadosTarefas, setDadosTarefas] = useState(null);

  async function listarQuantidadeTarefas() {
    try {
      const id_usuario = Cookies.get('id_usuario');
      const token = Cookies.get('token');

      const headers = {
        'Authorization': 'Bearer ' + token
      };



      // await api.get(
      //   `v1/protected/ordemservico/listartodossimplestarefas/${id_usuario}`,
      //   { headers }
      // ).then(function (response) {
      //   setDadosTarefas(response.data);
      // });

    } catch (_err) {
      console.log("Erro ao listar dados de tarefas: " + _err);
    }
  }




  // abre automaticamente se tiver tarefas abertas
  useEffect(() => {
    if (dadosTarefas && dadosTarefas.tarefasAbertasParaExecutar > 0) {
      setOpenBalaoTarefas(true);
    }
  }, [dadosTarefas]);


  useEffect(() => {

    //alert("Regras: " + regra);

    checkDimenssoes();
    listarRamais();
    listarLimites();
    listarDescontos();
    listarQuantidadeTarefas();

    const handleAbrirTarefas = () => {
      setOpenBalaoTarefas(true);
      setCompactadoTarefas(false);
      setSize({
        width: 350,
        height: "auto",
      });
    };

    window.addEventListener('abrirTarefasBalao', handleAbrirTarefas);

    return () => {
      window.removeEventListener('abrirTarefasBalao', handleAbrirTarefas);
    };
  }, []);






  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };


  async function handleOpenAlert(tarefa) {
    handleCloseBalaoNotificacao();
    console.log("handle open alert chamado!");
    // console.log(JSON.stringify(tarefa));
    //buscar OS anexada
    try {
      const token = Cookies.get('token');

      const headers = {
        'Authorization': 'Bearer ' + token
      }

      await api.get("/v1/protected/ordemservico/listarporid/" + tarefa.id_ordem_servico, {
        headers: headers
      }).then(function (response) {
        tarefa.ordem_servico = response.data
        setTarefaEmvista(tarefa);
        setAlertOpen(true);
        vizualizarTarefa(tarefa);
      });
    } catch (_err) {
      setTarefaEmvista(tarefa);
      setAlertOpen(true);
      vizualizarTarefa(tarefa);
    }

  };




  async function handleOpenAlertDireto() {
    setShow(false);
    console.log("handle open alert handleOpenAlertDireto chamado!");
    // console.log(JSON.stringify(tarefa));
    //buscar OS anexada
    try {
      const token = Cookies.get('token');

      const headers = {
        'Authorization': 'Bearer ' + token
      }

      await api.get("/v1/protected/ordemservico/listarporidparanavbar/" + oSOC.id_ordem_servico, {
        headers: headers
      }).then(function (response) {
        console.log("Os listada em handleOpenAlertDireto")
        setOSOC(response.data);
        if (response.data) {
          setAlertOpen2(true);
        }

      });
    } catch (_err) {

    }

  };





  async function vizualizarTarefa(tarefa) {
    try {


      console.log("Vizualizar tarefa chamado");
      const id_usuario = Cookies.get('id_usuario');


      var url = "v1/protected/tarefasgestao/vizualizar/" + parseInt(tarefa.id_tarefa);
      //console.log("Url: " + url);
      await api.put(url).then(function (response) {

        if (response) {
          // usa um nome diferente no callback para evitar shadowing
          setTarefas(prevTarefas => prevTarefas.filter(t => t.id_tarefa !== tarefa.id_tarefa));
        }
      });


    } catch (_err) {
      console.log("Erro ao vizualizar acao, err: " + _err);

    }
  }



  async function fecharTarefa(tarefa) {
    try {


      console.log("fechar tarefa chamado");
      const id_usuario = Cookies.get('id_usuario');


      var url = "v1/protected/tarefasgestao/fechar/" + parseInt(tarefa.id_tarefa);
      //console.log("Url: " + url);
      await api.put(url).then(function (response) {

        if (response) {
          setTarefas(tarefas.filter(tarefa => tarefa.id_tarefa !== tarefa.id_tarefa));

        }

      });

    } catch (_err) {
      console.log("Erro ao fechar acao, err: " + _err);

    }
  }


  async function criarOCporOs() {

    try {


      if (tarefaEmVista.ordem_servico.finalizar_requerimento_itens === 0) {
        alert("Aguarda até que o criador da O.S finalize o Requerimento de itens!");
        return;
      }

      const headers = {
        'Authorization': 'Bearer ' + Cookies.get("token")
      }

      const response = await api.post('/v1/protected/ordensdecompras/ordemdecompra/cadastrarporos/' + Cookies.get("id_usuario"), tarefaEmVista.ordem_servico,
        { headers: headers });

      const cadastro_salvo = response.data;
      if (cadastro_salvo) {
        alert("Ordem de Compra Cadastrada!");
        history.push({
          pathname: "/gestao/administracao/ordensdecompras/editar/" + cadastro_salvo.id_ordem_compra,
        })
      } else {
        alert("Erro de Conexão, tente novamente mais tarde");

      }


    } catch (_err) {
      console.log("erro ao cadastrar: " + _err);
      alert("Erro de Conexão, tente novamente mais tarde");

    }
  }





  async function criarOCporOs2() {

    try {


      if (oSOC.finalizar_requerimento_itens === 0) {
        alert("Aguarda até que o criador da O.S finalize o Requerimento de itens!");
        return;
      }

      const headers = {
        'Authorization': 'Bearer ' + Cookies.get("token")
      }

      const response = await api.post('/v1/protected/ordensdecompras/ordemdecompra/cadastrarporos/' + Cookies.get("id_usuario"), oSOC,
        { headers: headers });

      const cadastro_salvo = response.data;
      if (cadastro_salvo) {
        alert("Ordem de Compra Cadastrada!");
        history.push({
          pathname: "/gestao/administracao/ordensdecompras/editar/" + cadastro_salvo.id_ordem_compra,
        })
      } else {
        alert("Erro de Conexão, tente novamente mais tarde");

      }


    } catch (_err) {
      console.log("erro ao cadastrar: " + _err);
      alert("Erro de Conexão, tente novamente mais tarde");

    }
  }

  const formatarNome = (nomeCompleto) => {
    if (!nomeCompleto) return '';

    const partes = nomeCompleto.trim().split(' ');
    if (partes.length === 1) return partes[0];

    const primeiroNome = partes[0];
    const iniciaisSobrenome = partes
      .slice(1)
      .map(palavra => palavra.charAt(0).toUpperCase() + '.')
      .join(' ');

    return `${primeiroNome} ${iniciaisSobrenome}`;
  };



  const handleCloseAlert = () => {

    setAlertOpen(false);
    setTarefaEmvista(null);

  }

  const handleCloseAlert2 = () => {

    setAlertOpen2(false);

  }


  async function handleDescartarNotificacao() {


    if (tarefaEmVista.id_saida_estoque > 0) {
      //para ordes de compra
      fecharTarefa(tarefaEmVista);
      return "/gestao/operacional/almoxarifado/saidaestoque/gerenciarsaidaestoque/" + tarefaEmVista.id_saida_estoque;
    }
    else if (tarefaEmVista.especificidade === 0 && tarefaEmVista.ordem_compra) {
      //para ordes de compra
      fecharTarefa(tarefaEmVista);
      return "/gestao/administracao/ordensdecompras/editar/" + tarefaEmVista.ordem_compra.id_ordem_compra;
    }
    else if (tarefaEmVista.especificidade === 0) {
      fecharTarefa(tarefaEmVista);
      return "/gestao/administracao/ordensdecompras/editar/" + tarefaEmVista.id_ordem_compra;

    }
    else if (tarefaEmVista.especificidade === 1) {
      //verificar o status da ordem de servico e se o usuario atual é o usuario logado
      try {

        const token = Cookies.get('token');

        const headers = {
          'Authorization': 'Bearer ' + token
        }

        await api.get("/v1/protected/ordemservico/listarporid/" + tarefaEmVista.id_ordem_servico, {
          headers: headers
        }).then(function (response) {

          if (parseInt(response.data.usuario_executor_atual.id_usuario, 10) === parseInt(Cookies.get("id_usuario"), 10)) {
            if (parseInt(response.data.solicitacao.id_solicitacao, 10) === 7 && response.data.id_ordem_compra !== null && parseInt(response.data.id_ordem_compra, 10) !== null) {
              fecharTarefa(tarefaEmVista);
            } else {
              if (parseInt(response.data.status_ordem, 10) !== 9) {
                //ordem esta aberta e o usuario executando, nao permite fechar
                alert("A Ordem de Serviço está com status 'Em Andamento', como você é o usuário executor atual, a notificação não pode ser fechada");
              } else {
                //alert("Ordem de Serviço já finalizada!, pode fechar");
                fecharTarefa(tarefaEmVista);

              }
            }
          } else {
            //pode fechar a notificacao
            //alert("usuario nao é mais executor dessa O.S, pode fechar");
            fecharTarefa(tarefaEmVista);

          }

        });
      } catch (_err) {
        // avisar('Houve um problema com o login, verifique suas credenciais! ' + cpf + " " + senha );
        console.log("Erro ao listar informações: " + _err)

      }

    } else if (tarefaEmVista.especificidade === 2) {
      return "/gestao/financas/lancamento/gerenciar/" + tarefaEmVista.id_lancamento;

    }



  }

  function processarLink() {

    if (tarefaEmVista.id_saida_estoque > 0) {
      //para ordes de compra
      return "/gestao/operacional/almoxarifado/saidaestoque/gerenciarsaidaestoque/" + tarefaEmVista.id_saida_estoque;
    }
    else if (tarefaEmVista.especificidade === 0 && tarefaEmVista.ordem_compra) {
      //para ordes de compra
      return "/gestao/administracao/ordensdecompras/editar/" + tarefaEmVista.ordem_compra.id_ordem_compra;
    }
    else if (tarefaEmVista.especificidade === 0) {
      return "/gestao/administracao/ordensdecompras/editar/" + tarefaEmVista.id_ordem_compra;

    }
    else if (tarefaEmVista.especificidade === 1) {
      return "/gestao/administracao/ordensdeservicos/editar/" + tarefaEmVista.id_ordem_servico;

    } else if (tarefaEmVista.especificidade === 2) {
      return "/gestao/financas/lancamento/gerenciar/" + tarefaEmVista.id_lancamento;

    }



  }


  function processarLink2() {



    return "/gestao/administracao/ordensdeservicos/editar/" + oSOC.id_ordem_servico;





  }



  async function pesquisarProjetos() {


    const token = Cookies.get('token');

    const headers = {
      'Authorization': 'Bearer ' + token
    }



    // Listar projetos em andamento
    try {
      console.log("aqui 4");
      const responseProjetos = await api.get("v1/protected/projetos/listartodosrecentes");
      setProjetos(responseProjetos.data);
    } catch (error) {
      console.error("Erro ao buscar projetos:", error);
    }


  }


  async function pesquisarBackGround() {

    console.log("Pesquisando em background");

    const token = Cookies.get('token');
    const id_usuario_logado = Cookies.get('id_usuario');

    const headers = {
      'Authorization': 'Bearer ' + token
    }

    console.log("aqui 1");

    console.log("aqui 2");
    try {
      console.log("aqui 3");
      const responseOsParaOCs = await api.get("v1/protected/ordemservico/listarosocporusuario/" + id_usuario_logado);

      console.log(" resposta de Os para Ocs: " + responseOsParaOCs.data);

      setOSOC(responseOsParaOCs.data);
      if (responseOsParaOCs.data) {
        setShow(true);
      }
    } catch (error) {
      console.error("Erro ao buscar OS para OC:", error);
    }


    try {
      console.log("aqui 1.2");

      const url = "v1/protected/tarefasgestao/listarPorUsuario/" + id_usuario_logado;

      const response = await api.get(url);
      const tarefasUsuario = response.data;

      console.log("aqui 2");
      /*
        for (const item of tarefasUsuario) {
          if (item != null && item.especificidade === 1) {
            try {
              const response2 = await api.get(
                `/v1/protected/ordemservico/listarporid/${item.id_ordem_servico}`,
                { headers }
              );
  
              const ordem = response2.data;
  
              if (parseInt(ordem.solicitacao.id_solicitacao, 10) === 7) {
                setTarefaEmvista(item);
                handleOpenBalaoNotificacao();
                break;  
              } else if (ordem.criar_ordem === 1 && ordem.finalizar_requerimento_itens === 1) {
                setTarefaEmvista(item);
                handleOpenBalaoNotificacao();
                break; // Sai do loop após o primeiro match
  
              }
  
            } catch (error) {
              console.error("Erro ao buscar ordem:", error);
            }
          }
        }*/
      console.log("aqui 3");
      // Atualiza o estado de todas as tarefas
      setTarefas(tarefasUsuario);


      console.log("fim da pesquisa background");
      setLoading(false);

    } catch (_err) {
      console.log("erro pesquisa background" + _err);
    }
  }

  const [rondaVirtualPendente, setRondaVirtualPendente] = useState(null);


  async function pesquisarBackGroundRondas() {


    try {

      const id_usuario_logado = Cookies.get('id_usuario');

      let url = "v1/protected/rondavirtual/buscarpendente/" + id_usuario_logado;

      await api.get(url).then(function (response) {

        if (response.data) {
          if (response.data.usuario_executor) {

            if (parseInt(response.data.usuario_executor.id_usuario, 10) === parseInt(Cookies.get('id_usuario'), 10)) {

              setRondaVirtualEmAndamento(response.data);
              setOpenRondaVirtualEmAndamento(true);
            } else {
              setRondaVirtualPendente(null);
              handleCloseBalao();
            }
          } else {
            setRondaVirtualPendente(response.data);
            handleOpenBalao();
          }
        }
        else {
          console.log("Sem rondas pendentes!");
          setRondaVirtualPendente(null);
          handleCloseBalao();
        }


      });


    } catch (_err) {
      console.log("erro: " + _err);

    }


  }




  async function pesquisarBackGroundOCsFinanceiro() {
    try {
      const id_usuario_logado = Cookies.get('id_usuario');
      const url = "v1/protected/ordensdecompras/ordemdecompra/listarpendentedelancamento/" + id_usuario_logado;

      const response = await api.get(url);

      if (response.data) {
        // Se veio uma string, é uma mensagem de acesso
        if (typeof response.data === "string") {
          console.log("Mensagem do backend:", response.data);
          setOcPendente(null);
          setPesquisarOc(false);

          handleCloseBalaoOc();
        } else {
          // Veio um objeto OC válido
          console.log("Ordem de compra pendente encontrada:", response.data);
          setOcPendente(response.data);
          setPesquisarOc(true); // <-- indica que pode pesquisar
          handleOpenBalaoOc();
        }
      } else {
        console.log("Sem dados retornados do backend");
        setOcPendente(null);
        setPesquisarOc(false); // <-- sem dados, não pesquisar
        handleCloseBalaoOc();
      }


    } catch (_err) {
      console.log("Erro na requisição:", _err);
      setOcPendente(null);
      setPesquisarOc(false); // <-- erro, não pesquisar
      handleCloseBalaoOc();
    }
  }


  useEffect(() => {
    const isMonitoramento = location.pathname.includes('/tecnica/monitoramento');
    if (isMonitoramento) return;

    const interval = setInterval(() => {
      if (pesquisarOc) {
        pesquisarBackGroundOCsFinanceiro();
      }
    }, 60000);

    return () => clearInterval(interval);
  }, [pesquisarOc, location.pathname]);

  useEffect(() => {
    checkDimenssoes();

    const isMonitoramento = location.pathname.includes('/tecnica/monitoramento');
    if (isMonitoramento) {
      setLoading(false);
      return;
    }

    pesquisarProjetos();

    const t1 = setTimeout(() => {
      pesquisarBackGround();
    }, 2000); // 2s

    const t2 = setTimeout(() => {
      pesquisarBackGroundOCsFinanceiro();
    }, 20000); // 20s

    const t3 = setTimeout(() => {
      pesquisarBackGroundRondas();
    }, 30000); // 30s

    setLoading(false);

    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
      clearTimeout(t3);
    };
  }, [location.pathname]);

  useEffect(() => {
    const isMonitoramento = location.pathname.includes('/tecnica/monitoramento');

    if (isMonitoramento) return;

    const interval = setInterval(() => {
      if (regra.includes("MONITOR")) {
        pesquisarBackGroundRondas();
      }

    }, 120000);

    return () => clearInterval(interval);
  }, [location.pathname, rondaVirtualPendente]);


  useEffect(() => {
    const isMonitoramento = location.pathname.includes('/tecnica/monitoramento');
    if (isMonitoramento) return;

    const interval = setInterval(() => {
      pesquisarBackGround();
    }, 240000);

    return () => clearInterval(interval);

  }, [tarefas, location.pathname]);

  const toggleDrawer = (option) => (event) => {
    if (
      event &&
      event.type === 'keydown' &&
      (event.key === 'Tab' || event.key === 'Shift')
    ) {
      return;
    }

    if (option) {
      handleDrawerClose();
    } else {
      handleDrawerOpen();
    }

  };



  function onConfirmSair() {
    Cookies.set('token', undefined);
    window.location.href = "/login"


  }

  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedTerm, setDebouncedTerm] = useState("");

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedTerm(searchTerm);
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [searchTerm]);

  useEffect(() => {
    if (debouncedTerm.length >= 2) {
      buscarInstalacoes(debouncedTerm);
    } else {
      setInstalacoesEncontradas([]);
    }
  }, [debouncedTerm]);

  // Agora é uma função simples, SEM setSearchTerm
  async function buscarInstalacoes(termo) {
    try {
      const token = Cookies.get('token');
      const headers = {
        'Authorization': 'Bearer ' + token
      };

      const response = await api.get("/v1/protected/cliente/buscarparapesquisa/" + termo, {
        headers: headers
      });

      console.log(JSON.stringify(response.data));
      setInstalacoesEncontradas(response.data);
    } catch (err) {
      console.error("Erro ao listar informações: " + err);
    }
  }




  function returnDescricaoInstalacaoResumida(instalacao) {
    var texto = instalacao.identificador_integrador + "-" +
      (instalacao.tipo_instalacao === 0 ? (instalacao.nome + " " + instalacao.sobrenome) : instalacao.nome_fantasia);

    return texto;
  }

  const getConditionalStyle = (condition, isMobile = false) => {
    // Se precisar de estilos diferentes para mobile, basta ajustar aqui:
    const styleDesktop = {
      textDecoration: condition ? 'underline' : '',
      backgroundColor: condition ? (effectiveDarkMode ? 'rgba(255, 255, 255, 0.15)' : 'orange') : 'transparent',
      color: theme.text,
      borderRadius: '6px'
    };

    const styleMobile = {
      textDecoration: condition ? '' : '',
      // Por exemplo, um tom diferente para mobile:
      backgroundColor: condition ? (effectiveDarkMode ? 'rgba(255, 255, 255, 0.15)' : 'white') : 'transparent',
      color: theme.text,
      borderRadius: '6px'
    };

    return isMobile ? styleMobile : styleDesktop;
  };


  const [instalacoesEncontradas, setInstalacoesEncontradas] = useState([]);



  const getTitleConditionalStyle = (condition, isMobile = false, noPadding = false) => {
    // Estilos para desktop
    const styleDesktop = {
      backgroundColor: condition ? (effectiveDarkMode ? 'rgba(255, 255, 255, 0.15)' : '#FFA500') : 'transparent',
      fontSize: '14px',
      padding: noPadding ? '0px 0px' : '5px 10px',
      color: theme.text,
      textDecoration: condition ? 'underline' : 'none',
      borderRadius: '6px'
    };

    // Estilos para mobile (mantendo os mesmos atributos)
    const styleMobile = {
      textDecoration: condition ? 'none' : 'none',
      backgroundColor: condition ? (effectiveDarkMode ? 'rgba(255, 255, 255, 0.15)' : '#FFA500') : 'transparent',
      fontSize: '16px',
      color: theme.text,
      border: condition ? (effectiveDarkMode ? `2px solid ${theme.border}` : '2px solid #FFA500') : 'none',
      borderRadius: '8px',
      padding: '5px 10px',
      transition: 'background-color 0.3s, border-color 0.3s',
      textDecoration: 'none'
    };

    return isMobile ? styleMobile : styleDesktop;
  };



  function processarIconeInstalacao(tipo) {
    if (tipo === 0) {
      return icone_casa;
    } else if (tipo === 1) {
      return icone_loja;
    } else if (tipo == 2) {
      return icone_subestacao;
    }
  }


  const ClienteComponent = ({ id_cliente, cliente }) => {
    const handleClickGerenciarCliente = () => {
      const url = `/gestao/administracao/clientes/gerenciarcliente/${id_cliente}`;
      window.open(url, '_blank');
    };

    return (
      <Box border={`1px solid ${theme.border}`} borderRadius={6} padding={2} marginBottom={2} sx={{ bgcolor: theme.paper }}>
        <Grid container alignItems="center" justifyContent="space-between">
          <Grid item>
            <Typography variant="h6">{cliente.nome_fantasia}</Typography>
          </Grid>
          <Grid item>
            <IconButton color="primary" onClick={handleClickGerenciarCliente}>
              <SettingsIcon />
            </IconButton>
          </Grid>
        </Grid>

        <Box marginTop={2}>
          {cliente.instalacoes && cliente.instalacoes.length > 0 ? (
            cliente.instalacoes.map((instalacao) => (
              <LocalComponent
                key={instalacao.id_instalacao}
                id_instalacao={instalacao.id_instalacao}
                lat={instalacao.latitude}
                lng={instalacao.longitude}
                onClick={() => { }} // você pode passar algo útil aqui
                tipo_icone={instalacao.icone_mapa}
                nome_mapa={instalacao.nome_mapa}
                status={instalacao.status}
                instalacao={instalacao}
              />
            ))
          ) : (
            <Typography variant="body2" color="textSecondary">
              Nenhuma instalação cadastrada para este cliente.
            </Typography>
          )}
        </Box>
      </Box>
    );
  };


  const LocalComponent = ({ id_instalacao, lat, lng, onClick, tipo_icone, nome_mapa, status, instalacao }) => {
    const [showMenu, setShowMenu] = useState(false);

    const handleClickGerenciar = () => {
      const url = `/gestao/administracao/clientes/gerenciarcliente/instalacao/gerenciarinstalacao/${id_instalacao}/0`;
      window.open(url, '_blank');
      setShowMenu(!showMenu);
    };

    const abrirProjeto = (id_projeto) => {
      const url = `/gestao/administracao/projetos/editaroprojeto/${id_projeto}/1/${id_instalacao}/0`;
      window.open(url, '_blank');
    };

    const abrirProposta = (id_projeto, id_proposta) => {
      ///gestao/administracao/projetos/editarprojeto/13/propostas/editarproposta/10/1/739/0
      const url = `/gestao/administracao/projetos/editarprojeto/${id_projeto}/propostas/editarproposta/${id_proposta}/1/${id_instalacao}/0`;
      window.open(url, '_blank');
    };

    const handleOnClickAreaTecnica = () => {
      const url = `/tecnica/monitoramento/dashboard/${id_instalacao}/${instalacao.identificador_integrador}`;
      window.open(url, '_blank');
    };

    return (
      <Grid container direction="row" justifyContent="center" alignItems="center" item xs={12} style={{ padding: 10 }}>
        <Grid container direction="row" justifyContent="flex-start" alignItems="center" item xs={12} spacing={1}>
          <Grid item>
            <img
              alt={"icone"}
              style={{ textAlign: 'center', width: '40px', height: '40px' }}
              src={processarIconeInstalacao(tipo_icone)}
            />
          </Grid>
          <Grid item>
            <Typography style={{ textDecoration: "underline" }}>
              {instalacao.nome_fantasia}
            </Typography>
          </Grid>
          <Grid item>
            <Typography style={{ textDecoration: "underline" }}>
              {(instalacao.nome_mapa ? instalacao.nome_mapa : "") + " - " + instalacao.identificador_integrador}
            </Typography>
          </Grid>
          <Grid item>
            <IconButton color="primary" onClick={handleClickGerenciar}>
              <SettingsIcon />
            </IconButton>
          </Grid>
        </Grid>

        <Grid container direction="column" justifyContent="center" alignItems="center" item xs={4}>
          <Button
            color="primary"
            startIcon={<BuildIcon />}
            onClick={handleOnClickAreaTecnica}
            style={{ padding: 10, margin: 10 }}
          >
            Área Técnica
          </Button>
        </Grid>

        {/* Lista de projetos da instalação */}
        {instalacao.projetos && instalacao.projetos.filter(p => p !== null).length > 0 && (
          <Grid container direction="column" spacing={2} style={{ marginTop: 10, paddingLeft: 10, border: `1px solid ${theme.border}`, borderRadius: 6 }}>
            {instalacao.projetos
              .filter(projeto => projeto !== null)
              .map((projeto) => (
                <Box key={projeto.id_projeto} mb={2} style={{ padding: 10, border: `1px solid ${theme.border}`, borderRadius: 6 }}>
                  <Box display="flex" alignItems="center" mb={1}>
                    <FolderIcon color="primary" style={{ marginRight: 6 }} />
                    <Button
                      variant="outlined"
                      size="small"
                      color="primary"
                      onClick={() => abrirProjetoB(projeto.id_projeto, projeto.instalacao?.id_instalacao)}
                      style={{ textTransform: 'none' }}
                    >
                      Projeto ID {projeto.id_projeto} -{' '}
                      {projeto.nome_projeto
                        ? (projeto.nome_projeto.length > 50
                          ? projeto.nome_projeto.substring(0, 50) + '...'
                          : projeto.nome_projeto)
                        : ''} -{' '}
                      {projeto.descricao_projeto
                        ? (projeto.descricao_projeto.length > 50
                          ? projeto.descricao_projeto.substring(0, 50) + '...'
                          : projeto.descricao_projeto)
                        : ''}
                    </Button>
                  </Box>

                  {/* Lista de propostas do projeto */}
                  {projeto.propostas && projeto.propostas.filter(pr => pr !== null).length > 0 && (
                    <Box ml={4}>
                      {projeto.propostas
                        .filter(proposta => proposta !== null)
                        .map((proposta) => (
                          <Box key={proposta.id_proposta} display="flex" alignItems="center" mb={0.5}>
                            <DescriptionIcon color="action" style={{ marginRight: 6 }} />
                            <Button
                              size="small"
                              color="secondary"
                              variant="text"
                              onClick={() => abrirProposta(projeto.id_projeto, proposta.id_proposta)}
                              style={{ textTransform: 'none', padding: 0, minWidth: 'auto' }}
                            >
                              Proposta ID {proposta.id_proposta} - {proposta.descricao_proposta}
                            </Button>
                          </Box>
                        ))}
                    </Box>
                  )}
                </Box>
              ))}
          </Grid>
        )}
      </Grid>
    );
  };


  const abrirProjetoB = (id_projeto, id_instalacao) => {
    const url = `/gestao/administracao/projetos/editaroprojeto/${id_projeto}/1/${id_instalacao}/0`;
    window.open(url, '_blank');
  };

  const abrirPropostaB = (id_projeto, id_proposta, id_instalacao) => {
    ///gestao/administracao/projetos/editarprojeto/13/propostas/editarproposta/10/1/739/0
    const url = `/gestao/administracao/projetos/editarprojeto/${id_projeto}/propostas/editarproposta/${id_proposta}/1/${id_instalacao}/0`;
    window.open(url, '_blank');
  };

  const [isReadOnly, setIsReadOnly] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsReadOnly(false); // Libera o campo após um delay
    }, 500);
    return () => clearTimeout(timer);
  }, []);

  if (loadingCliente) {
    return <div style={{ height: '60px', width: '100%', backgroundColor: effectiveDarkMode ? theme.navbarBg : (props.corFundo || 'white') }} />;
  }

  return (
    <div
      style={{
        zIndex: 1100,
        backgroundColor: larguraOriginal < limiar && !navbarExpanded ? 'transparent' : (effectiveDarkMode ? theme.navbarBg : (navBar === true ? 'white' : props.corFundo)),
        color: theme.text,
        position: larguraOriginal < limiar ? 'fixed' : (props.travado ? 'sticky' : null),
        top: 0,
        left: 0,
        width: '100%',
        height: larguraOriginal < limiar && !navbarExpanded ? '10px' : 'auto',
        borderBottom: larguraOriginal < limiar && !navbarExpanded ? 'none' : `1px solid ${theme.border}`,
        transition: 'background-color 0.3s, height 0.3s'
      }}
      onTouchStart={handleTouchStart}
      onTouchMove={(e) => {
        if (larguraOriginal < limiar) {
          e.preventDefault();
        }
      }}
      onTouchEnd={handleTouchEnd}

    >
      {/* Top Handle for Mobile */}
      {larguraOriginal < limiar && !navbarExpanded && (
        <div
          onClick={() => setNavbarExpanded(true)}
          style={{
            position: 'absolute',
            top: '0px',
            left: '50%',
            transform: 'translateX(-50%)',
            width: '60px',
            height: '20px', // Hit area
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'flex-start',
            zIndex: 1101, // Above navbar background
            cursor: 'pointer',
            touchAction: 'none'
          }}
          onTouchMove={(e) => e.preventDefault()}
        >
          <div style={{
            width: '40px',
            height: '4px',
            backgroundColor: effectiveDarkMode ? 'rgba(255, 255, 255, 0.3)' : 'rgba(0, 0, 0, 0.2)',
            borderRadius: '2px',
            marginTop: '8px' // Push it down a bit
          }} />
        </div>
      )}

      {effectiveDarkMode && (
        <style>
          {`
            .color-nav {
              background-color: ${theme.navbarBg} !important;
            }
            .dropdown-menu, .nav-item .dropdown-menu {
              background-color: ${theme.paper} !important;
              color: ${theme.text} !important;
              border: 1px solid ${theme.border} !important;
            }
            .dropdown-item, .nav-item .dropdown-item {
              color: ${theme.text} !important;
              background-color: transparent !important;
            }
            .dropdown-item:hover, .nav-item .dropdown-item:hover {
              background-color: rgba(255, 255, 255, 0.12) !important;
              color: #ffffff !important;
            }
            .navbar-nav .nav-link {
               color: ${theme.text} !important;
            }
            
            /* Hover nos menus no modo escuro (substitui o laranja chamativo por tom sofisticado e suave) */
            .navbar-nav .nav-link:hover,
            .nav-link:hover,
            #nav-link:hover,
            #nav-dropdown:hover,
            #nav-dropdownmobile:hover,
            .dropdown-toggle:hover,
            .nav-item:hover > .nav-link,
            .nav-dropdown:hover,
            .minha-conta:hover {
              background-color: rgba(255, 255, 255, 0.12) !important;
              color: #ffffff !important;
              text-decoration: none !important;
              border-radius: 6px !important;
            }

            /* Barra de pesquisa no modo escuro */
            input[name="real_search_no_autofill"],
            input[name="real_search_no_autofill_mobile"] {
              background-color: ${theme.paper} !important;
              color: ${theme.text} !important;
              border: 1px solid ${theme.border} !important;
            }
            input[name="real_search_no_autofill"]::placeholder,
            input[name="real_search_no_autofill_mobile"]::placeholder {
              color: #94a3b8 !important;
              opacity: 0.8;
            }
            input[name="real_search_no_autofill"]:focus,
            input[name="real_search_no_autofill_mobile"]:focus {
              border-color: #0284c7 !important;
              outline: none !important;
              box-shadow: 0 0 0 2px rgba(2, 132, 199, 0.25) !important;
            }
            
            /* Overrides for IDs in styles.css */
            #nav-dropdown, #nav-dropdownmobile {
               background-color: transparent !important;
               color: ${theme.text} !important;
            }
            
            /* Mobile styles overrides */
            .mobile, .mobilesubmenu, #nav-linkmobile {
               background-color: ${theme.paper} !important;
               color: ${theme.text} !important;
               border-color: ${theme.border} !important;
            }
            .mobile:hover, .mobilesubmenu:hover, .nav-dropdownmobile:hover {
               background-color: rgba(255, 255, 255, 0.12) !important;
               border-color: ${theme.border} !important;
               color: #ffffff !important;
            }
          `}
        </style>
      )}
      <Grid
        container
        direction="row"
        item xs={12} sm={12} md={12} lg={12} xl={12}

      >
        {larguraOriginal > limiar && (
          <Grid
            container
            direction="row"
            item xs={12} sm={3} md={3} lg={3} xl={3}
            alignItems="center"
            justifyContent="center"
            style={{ padding: 10 }}
          >
            <div style={{}}>
              <Link className="a"

                to={{
                  pathname: "/",

                }}
              >
                <img alt="logomarca" width={200}
                  src={effectiveDarkMode ? logo_fundo_preto : logo}
                />
              </Link>
            </div>
          </Grid>
        )}

        <Grid
          container
          direction="row"
          item xs={12} sm={8} md={8} lg={8} xl={9}
          alignItems="center"
          justifyContent={larguraOriginal < limiar ? "flex-start" : "center"}
        >
          <Navbar expand="xl" className={"color-nav"} variant={theme.navbarVariant} expanded={navbarExpanded} onToggle={(expanded) => setNavbarExpanded(expanded)}>
            <Container  >
              {larguraOriginal >= limiar && (
                <Navbar.Toggle aria-controls="basic-navbar-nav" style={{ marginBottom: 10, backgroundColor: effectiveDarkMode ? '#999' : 'white' }} />
              )}


              {larguraOriginal >= limiar && !isCliente && (
                <input
                  type="search"
                  placeholder="Pesquisar..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  autoComplete="off"
                  readOnly={isReadOnly}  // Impede autofill inicial
                  name="real_search_no_autofill"
                  style={{
                    padding: "5px 10px",
                    flexGrow: 1,
                    maxWidth: "140px",
                    borderRadius: "8px",
                    border: effectiveDarkMode ? `1px solid ${theme.border}` : "1px solid #ccc",
                    backgroundColor: effectiveDarkMode ? theme.paper : 'white',
                    color: effectiveDarkMode ? theme.text : '#000000',
                    marginLeft: "10px",
                    outline: "none",
                    fontSize: "0.85rem"
                  }}
                />
              )}


              <Navbar.Collapse
                style={{
                  backgroundColor: larguraOriginal < limiar ? (effectiveDarkMode ? theme.bg : "white") : "transparent",
                  padding: larguraOriginal < limiar ? '20px' : null,
                  position: larguraOriginal < limiar ? 'fixed' : 'relative',
                  top: larguraOriginal < limiar ? 0 : 'auto',
                  left: larguraOriginal < limiar ? 0 : 'auto',
                  width: larguraOriginal < limiar ? '100%' : 'auto',
                  height: larguraOriginal < limiar ? '100%' : 'auto',
                  zIndex: larguraOriginal < limiar ? 9999 : 'auto',
                  overflowY: larguraOriginal < limiar ? 'auto' : 'visible',
                  display: larguraOriginal < limiar && !navbarExpanded ? 'none' : 'block'
                }} >

                {larguraOriginal < limiar && (
                  <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '20px' }}>
                    <IconButton onClick={() => setNavbarExpanded(false)} style={{ color: theme.text }}>
                      <CloseIcon style={{ fontSize: '30px' }} />
                    </IconButton>
                  </div>
                )}

                {larguraOriginal < limiar && !isCliente && (
                  <div style={{ padding: '0 10px', marginBottom: '20px' }}>
                    <input
                      type="search"
                      placeholder="Pesquisar..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      autoComplete="off"
                      readOnly={isReadOnly}
                      name="real_search_no_autofill_mobile"
                      style={{
                        padding: "5px 10px",
                        width: '100%',
                        height: '35px',
                        borderRadius: "8px",
                        border: effectiveDarkMode ? `1px solid ${theme.border}` : "1px solid #ccc",
                        backgroundColor: effectiveDarkMode ? theme.paper : 'white',
                        color: theme.text,
                        fontSize: '0.9rem',
                        outline: 'none'
                      }}
                    />
                  </div>
                )}


                <Nav style={{
                  border: larguraOriginal < limiar ? (effectiveDarkMode ? '1px solid #444' : '1px solid black') : null,
                  padding: larguraOriginal < limiar ? 10 : null,
                  borderRadius: larguraOriginal < limiar ? '5px' : null,
                  backgroundColor: larguraOriginal < limiar ? (effectiveDarkMode ? theme.bg : 'white') : 'transparent',
                  flexDirection: larguraOriginal < limiar ? 'column' : 'row',
                  width: larguraOriginal < limiar ? '100%' : 'auto'
                }}>

                  {(regra.includes("ADMIN") || isCliente)
                    && (
                      <NavDropdown
                        title={
                          <span
                            style={getTitleConditionalStyle(props.AreaTecnica, larguraOriginal < limiar)}
                          >
                            Área Técnica
                          </span>
                        }
                        // id={larguraOriginal > limiar ? 'nav-dropdown' : 'nav-dropdownmobile'}
                        style={getConditionalStyle(props.AreaTecnica, larguraOriginal < limiar)}
                        drop={larguraOriginal < limiar ? "down" : "down"}
                        className={larguraOriginal < limiar ? 'dropdown-mainmenu' : ''}
                      >
                        <NavDropdown
                          title={

                            <span
                              style={getTitleConditionalStyle(props.Monitoramento, larguraOriginal < limiar)}
                            >
                              Monitoramento
                            </span>
                          }
                          id={larguraOriginal > limiar ? 'nav-dropdown' : 'nav-dropdownmobile'}
                          style={getConditionalStyle(props.Monitoramento, larguraOriginal < limiar)}
                          className={larguraOriginal < limiar ? 'dropdown-submenu' : ''}
                          drop={larguraOriginal < limiar ? "start" : "down"}
                        >
                          <NavDropdown.Item
                            eventKey="1.0"
                            style={getTitleConditionalStyle(props.MonitoramentoMosaico, larguraOriginal < limiar)}
                            href="/tecnica/monitoramento/mosaico"
                            target={larguraOriginal > limiar ? "_blank" : ''}
                            rel="noopener noreferrer" // Segurança ao abrir links externos
                          >
                            Mosaico
                          </NavDropdown.Item>

                          <NavDropdown.Item
                            eventKey="1.0"
                            style={getTitleConditionalStyle(props.MonitoramentoDashboard, larguraOriginal < limiar)}
                            href="/tecnica/monitoramento/dashboard">Dashboard
                          </NavDropdown.Item>

                          <NavDropdown.Item
                            eventKey="1.0"
                            style={getTitleConditionalStyle(props.MonitoramentoOperacao, larguraOriginal < limiar)}
                            href="/tecnica/monitoramento/operacao">Operação
                          </NavDropdown.Item>


                          <NavDropdown.Item
                            eventKey="1.0"
                            style={getTitleConditionalStyle(props.MonitoramentoMapa, larguraOriginal < limiar)}
                            href="/tecnica/monitoramento/mapa">Mapa
                          </NavDropdown.Item>

                          <NavDropdown.Item
                            eventKey="1.0"
                            style={getTitleConditionalStyle(props.MonitoramentoAuditoria, larguraOriginal < limiar)}
                            href="/tecnica/monitoramento/auditoria">Auditoria
                          </NavDropdown.Item>


                        </NavDropdown>

                        {!isCliente && (
                          <>
                            <NavDropdown.Item
                              eventKey="1.0"
                              style={getTitleConditionalStyle(props.Equipamentos, larguraOriginal < limiar)}
                              href="/tecnica/equipamentos">
                              Equipamentos
                            </NavDropdown.Item>

                            <NavDropdown.Item
                              eventKey="1.0"
                              style={getTitleConditionalStyle(props.Modulos, larguraOriginal < limiar)}
                              href="/tecnica/modulos">
                              Módulos
                            </NavDropdown.Item>

                          </>
                        )}


                      </NavDropdown>
                    )
                  }



                  {regra.includes("ADMIN") && !isCliente
                    && (
                      <NavDropdown
                        title={
                          <span
                            style={getTitleConditionalStyle(props.BaseDados, larguraOriginal < limiar)}
                          >
                            Base de Dados
                          </span>
                        }

                        style={getConditionalStyle(props.BaseDados, larguraOriginal < limiar)}
                        align={larguraOriginal < limiar ? "end" : ''}
                        className={larguraOriginal < limiar ? 'dropdown-mainmenu' : ''}

                      >
                        <NavDropdown.Item
                          eventKey="1.0"
                          style={getTitleConditionalStyle(props.Unidades, larguraOriginal < limiar)}
                          href="/gestao/administracao/unidades/listar"
                        >Unidades
                        </NavDropdown.Item>

                        <NavDropdown.Item
                          eventKey="1.0"
                          style={getTitleConditionalStyle(props.Clientes, larguraOriginal < limiar)}
                          href="/gestao/administracao/clientes/listar"
                        >Clientes
                        </NavDropdown.Item>

                        <NavDropdown.Item
                          eventKey="1.0"
                          style={getTitleConditionalStyle(props.PessoasInteresse, larguraOriginal < limiar)}
                          href="/gestao/administracao/pessoasinteresse/listar"
                        >Pessoas de Interesse
                        </NavDropdown.Item>

                        <NavDropdown.Item
                          eventKey="1.0"
                          style={getTitleConditionalStyle(props.Projetos, larguraOriginal < limiar)}
                          href="/gestao/administracao/projetos/listar"
                        >Projetos
                        </NavDropdown.Item>


                        <NavDropdown.Item
                          eventKey="1.0"
                          style={getTitleConditionalStyle(props.PeD, larguraOriginal < limiar)}
                          href="/gestao/administracao/ped/listar"
                        >P & D
                        </NavDropdown.Item>

                        <NavDropdown
                          title={
                            <span
                              className={larguraOriginal < limiar ? 'mobile' : ''}
                            >
                              Tabelas Auxiliares
                            </span>
                          }
                          id={larguraOriginal > limiar ? 'nav-dropdown' : 'nav-dropdownmobile'}
                          style={getConditionalStyle(props.TabelasAuxiliaresClientes, larguraOriginal < limiar)}
                        >
                          <NavDropdown.Item eventKey="1.0" style={{ textDecoration: props.GruposClientes ? 'underline' : 'white', backgroundColor: props.GruposClientes ? 'orange' : 'white' }} id="nav-link" href="/gestao/administracao/clientes/gruposclientes/listar">Grupos de Clientes
                          </NavDropdown.Item>

                          <NavDropdown.Item eventKey="1.0" style={{ textDecoration: props.GruposControle ? 'underline' : 'white', backgroundColor: props.GruposControle ? 'orange' : 'white' }} id="nav-link" href="/gestao/administracao/clientes/gruposcontrole/listar">Grupos de Controle
                          </NavDropdown.Item>


                        </NavDropdown>


                      </NavDropdown>
                    )
                  }



                  {!isCliente && (
                  <NavDropdown
                    title={
                      <span
                        style={getTitleConditionalStyle(props.Operacional, larguraOriginal < limiar)}
                      >
                        Operacional
                      </span>
                    }

                    style={getConditionalStyle(props.Operacional, larguraOriginal < limiar)}
                    align={larguraOriginal < limiar ? "end" : ''}
                    className={larguraOriginal < limiar ? 'dropdown-mainmenu' : ''}

                  >

                    <NavDropdown.Item
                      eventKey="1.0"
                      style={getTitleConditionalStyle(props.ServicosOperacionais, larguraOriginal < limiar)}
                      id="nav-link"
                      href="/gestao/operacional/servicosoperacionais/listar"
                    >
                      Serviços Operacionais
                    </NavDropdown.Item>


                    <NavDropdown.Item
                      eventKey="1.0"
                      style={getTitleConditionalStyle(props.Agendamentos, larguraOriginal < limiar)}
                      id="nav-link"
                      href="/gestao/operacional/agendamentos/listar"
                    >
                      Agendamentos
                    </NavDropdown.Item>

                    <NavDropdown.Item
                      eventKey="1.0"
                      style={getTitleConditionalStyle(props.Equipes, larguraOriginal < limiar)}
                      id="nav-link"
                      href="/gestao/operacional/equipes/listar"
                    >
                      Equipes
                    </NavDropdown.Item>

                    <NavDropdown.Item
                      eventKey="1.0"
                      style={getTitleConditionalStyle(props.Solicitacoes, larguraOriginal < limiar)}
                      id="nav-link"
                      href="/gestao/operacional/solicitacoes/listar"
                    >
                      Solicitações
                    </NavDropdown.Item>

                    <NavDropdown.Item
                      eventKey="1.0"
                      style={getTitleConditionalStyle(props.Procedimentos, larguraOriginal < limiar)}
                      id="nav-link"
                      href="/gestao/operacional/procedimentos/listar"
                    >
                      Procedimentos
                    </NavDropdown.Item>

                    <NavDropdown.Item
                      eventKey="1.0"
                      style={getTitleConditionalStyle(props.Veiculos, larguraOriginal < limiar)}
                      id="nav-link"
                      href="/gestao/operacional/frota/veiculos/listar"
                    >
                      Veículos
                    </NavDropdown.Item>

                    <NavDropdown.Item
                      eventKey="1.0"
                      style={getTitleConditionalStyle(props.Rotas, larguraOriginal < limiar)}
                      id="nav-link"
                      href="/gestao/operacional/frota/rotas/listar"
                    >
                      Rotas
                    </NavDropdown.Item>

                    <NavDropdown.Item
                      eventKey="1.0"
                      style={getTitleConditionalStyle(props.RondaVirtual, larguraOriginal < limiar)}
                      id="nav-link"
                      href="/gestao/operacional/rondavirtual/listar"
                    >
                      Ronda Virtual
                    </NavDropdown.Item>

                    <NavDropdown.Item
                      eventKey="1.0"
                      style={getTitleConditionalStyle(props.RondaMotorizada, larguraOriginal < limiar)}
                      id="nav-link"
                      href="/gestao/operacional/rondamotorizada/listar"
                    >
                      Ronda Motorizada
                    </NavDropdown.Item>



                    <NavDropdown
                      title={
                        <span
                          style={getTitleConditionalStyle(props.Notificacoes, larguraOriginal < limiar)}
                        >
                          Notificações
                        </span>
                      }

                      style={getConditionalStyle(props.Notificacoes, larguraOriginal < limiar)}
                      align={larguraOriginal < limiar ? "end" : ''}
                      className={larguraOriginal < limiar ? 'dropdown-mainmenu' : ''}

                    >

                      <NavDropdown.Item
                        eventKey="1.0"
                        style={getTitleConditionalStyle(props.Notificacoes, larguraOriginal < limiar)}
                        id="nav-link"
                        href="/gestao/operacional/notificacoes/listar"
                      >
                        Notificações
                      </NavDropdown.Item>




                      <NavDropdown
                        title={
                          <span
                            className={larguraOriginal < limiar ? 'mobile' : ''}
                          >
                            Tabelas Auxiliares
                          </span>
                        }
                        id={larguraOriginal > limiar ? 'nav-dropdown' : 'nav-dropdownmobile'}
                        style={getConditionalStyle(props.TabelasAuxiliares, larguraOriginal < limiar)}
                      >
                        <NavDropdown.Item eventKey="1.0" style={{ textDecoration: props.TipoOcorrencias ? 'underline' : 'white', backgroundColor: props.TipoOcorrencias ? 'orange' : 'white' }} id="nav-link" href="/gestao/operacional/notificacoes/tiposocorrencias/listar">Tipos de Ocorrências
                        </NavDropdown.Item>


                      </NavDropdown>

                    </NavDropdown>

                  </NavDropdown>
                  )}



                  {!isCliente && (
                  <NavDropdown
                    title={
                      <span style={getTitleConditionalStyle(props.Almoxarifado, larguraOriginal < limiar)}>
                        Almoxarifado
                      </span>
                    }
                    id={larguraOriginal > limiar ? 'nav-dropdown' : 'nav-dropdownmobile'}
                    style={getConditionalStyle(props.Almoxarifado, larguraOriginal < limiar)}
                    align={larguraOriginal < limiar ? "end" : ''}
                    className={larguraOriginal < limiar ? 'dropdown-mainmenu' : ''}
                  >
                    <NavDropdown.Item
                      eventKey="1.0"
                      style={getTitleConditionalStyle(props.Insumos, larguraOriginal < limiar)}
                      id="nav-link"
                      href="/gestao/operacional/almoxarifado/insumos/listar"
                    >
                      Insumos
                    </NavDropdown.Item>

                    <NavDropdown.Item
                      eventKey="1.0"
                      style={getTitleConditionalStyle(props.Armazenamento, larguraOriginal < limiar)}
                      id="nav-link"
                      href="/gestao/operacional/almoxarifado/armazenamento/listar"
                    >
                      Armazenamento
                    </NavDropdown.Item>

                    <NavDropdown.Item
                      eventKey="1.0"
                      style={getTitleConditionalStyle(props.OpEntrada, larguraOriginal < limiar)}
                      id="nav-link"
                      href="/gestao/operacional/almoxarifado/entradaestoque/listar"
                    >
                      Operações de Entrada
                    </NavDropdown.Item>


                    <NavDropdown.Item
                      eventKey="1.0"
                      style={getTitleConditionalStyle(props.OpSaida, larguraOriginal < limiar)}
                      id="nav-link"
                      href="/gestao/operacional/almoxarifado/saidaestoque/listar"
                    >
                      Operações de Saída
                    </NavDropdown.Item>


                    <NavDropdown.Item
                      eventKey="1.0"
                      style={getTitleConditionalStyle(props.Estoque, larguraOriginal < limiar)}
                      id="nav-link"
                      href="/gestao/operacional/almoxarifado/estoque/listar"
                    >
                      Estoque
                    </NavDropdown.Item>

                    <NavDropdown.Item
                      eventKey="1.0"
                      style={getTitleConditionalStyle(props.Fornecedores, larguraOriginal < limiar)}
                      id="nav-link"
                      href="/gestao/operacional/almoxarifado/fornecedores/listar/1"
                    >
                      Fornecedores
                    </NavDropdown.Item>
                  </NavDropdown>
                  )}




                  {(regra.includes("ADMIN") || regra.includes("TEC_OS") || isCliente)
                    && (
                      <NavDropdown
                        title={
                          <span style={getTitleConditionalStyle(props.Gestao, larguraOriginal < limiar)}>
                            Gestão
                          </span>
                        }
                        id={larguraOriginal > limiar ? 'nav-dropdown' : 'nav-dropdownmobile'}
                        style={getConditionalStyle(props.Gestao, larguraOriginal < limiar)}
                        align={larguraOriginal < limiar ? "end" : ''}
                        className={larguraOriginal < limiar ? 'dropdown-mainmenu' : ''}
                      >




                        {(regra.includes("SUPER_ADMIN") || regra.includes("ADMIN_FINAN")) && !isCliente && (
                          <NavDropdown.Item
                            eventKey="2.0"
                            style={getTitleConditionalStyle(props.Lancamento, larguraOriginal < limiar)}
                            id="nav-link"
                            href="/gestao/financas/lancamento/listar"
                          >
                            Financeiro
                          </NavDropdown.Item>
                        )}



                        {(regra.includes("SUPER_ADMIN") || regra.includes("ADMIN_OC")) && !isCliente && (
                          <NavDropdown.Item
                            eventKey="1.0"
                            style={getTitleConditionalStyle(props.OrdensCompras, larguraOriginal < limiar)}
                            id="nav-link"
                            href="/gestao/administracao/ordensdecompras/listar"
                          >
                            Ordens de Compras
                          </NavDropdown.Item>
                        )}


                        {(regra.includes("SUPER_ADMIN") || regra.includes("ADMIN_OS") || regra.includes("TEC_OS") || isCliente) && (
                          <NavDropdown.Item
                            eventKey="2.0"
                            style={getTitleConditionalStyle(props.OrdensServicos, larguraOriginal < limiar)}
                            id="nav-link"
                            href="/gestao/administracao/ordensdeservicos/listar"
                          >
                            Ordens de Serviços
                          </NavDropdown.Item>
                        )}




                        {(regra.includes("SUPER_ADMIN") || regra.includes("ADMIN_RH")) && !isCliente
                          && (
                            <NavDropdown
                              title={
                                <span style={getTitleConditionalStyle(props.RH, larguraOriginal < limiar, true)}>
                                  Recursos Humanos
                                </span>
                              }
                              id={larguraOriginal > limiar ? 'nav-link' : 'nav-link'}
                              style={getConditionalStyle(props.RH, larguraOriginal < limiar)}
                              align={larguraOriginal < limiar ? "end" : ''}
                              className={larguraOriginal < limiar ? 'dropdown-mainmenu' : ''}
                            >
                              <NavDropdown.Item
                                eventKey="1.0"
                                style={getTitleConditionalStyle(props.Colaboradores, larguraOriginal < limiar)}
                                id="nav-link"
                                href="/gestao/rh/colaboradores/listar"
                              >
                                Colaboradores
                              </NavDropdown.Item>

                              <NavDropdown
                                title={
                                  <span style={getTitleConditionalStyle(props.TabelasAuxiliaresRh, larguraOriginal < limiar)}>
                                    Tabelas Auxiliares
                                  </span>
                                }
                                id={larguraOriginal > limiar ? 'nav-dropdown' : 'nav-dropdownmobile'}
                                style={getConditionalStyle(props.TabelasAuxiliaresRh, larguraOriginal < limiar)}
                                align={larguraOriginal < limiar ? "end" : ''}
                                className={larguraOriginal < limiar ? 'dropdown-submenu' : ''}
                              >
                                <NavDropdown.Item
                                  eventKey="1.1"
                                  style={getTitleConditionalStyle(props.Funcoes, larguraOriginal < limiar)}
                                  id="nav-link"
                                  href="/gestao/rh/funcoes/listar"
                                >
                                  Funções
                                </NavDropdown.Item>

                                <NavDropdown.Item
                                  eventKey="1.2"
                                  style={getTitleConditionalStyle(props.Departamentos, larguraOriginal < limiar)}
                                  id="nav-link"
                                  href="/gestao/rh/departamentos/listar"
                                >
                                  Departamentos
                                </NavDropdown.Item>

                                <NavDropdown.Item
                                  eventKey="1.3"
                                  style={getTitleConditionalStyle(props.Cargos, larguraOriginal < limiar)}
                                  id="nav-link"
                                  href="/gestao/rh/cargos/listar"
                                >
                                  Cargos
                                </NavDropdown.Item>
                              </NavDropdown>
                            </NavDropdown>

                          )
                        }


                        {(regra.includes("SUPER_ADMIN") || regra.includes("ADMIN_FINAN")) && !isCliente
                          && (
                            <NavDropdown
                              title={
                                <span style={getTitleConditionalStyle(props.Financas, larguraOriginal < limiar, true)}>
                                  Finanças
                                </span>
                              }
                              id={larguraOriginal > limiar ? 'nav-dropdown' : 'nav-dropdownmobile'}
                              style={getConditionalStyle(props.Financas, larguraOriginal < limiar)}
                              align={larguraOriginal < limiar ? "end" : ''}
                              className={larguraOriginal < limiar ? 'dropdown-mainmenu' : ''}
                            >
                              <NavDropdown
                                title={
                                  <span style={getTitleConditionalStyle(props.TabelasAuxiliaresFinancas, larguraOriginal < limiar)}>
                                    Tabelas Auxiliares
                                  </span>
                                }
                                id={larguraOriginal > limiar ? 'nav-dropdown' : 'nav-dropdownmobile'}
                                style={getConditionalStyle(props.TabelasAuxiliaresFinancas, larguraOriginal < limiar)}
                                align={larguraOriginal < limiar ? "end" : ''}
                                className={larguraOriginal < limiar ? 'dropdown-submenu' : ''}
                              >
                                <NavDropdown.Item
                                  eventKey="1.0"
                                  style={getTitleConditionalStyle(props.MetodosPagamento, larguraOriginal < limiar)}
                                  id="nav-link"
                                  href="/gestao/financas/metodospagamento/listar"
                                >
                                  Métodos de Pagamento
                                </NavDropdown.Item>

                                <NavDropdown.Item
                                  eventKey="1.1"
                                  style={getTitleConditionalStyle(props.CondicoesPagamento, larguraOriginal < limiar)}
                                  id="nav-link"
                                  href="/gestao/financas/condicoespagamento/listar"
                                >
                                  Condições de Pagamento
                                </NavDropdown.Item>

                                <NavDropdown.Item
                                  eventKey="1.2"
                                  style={getTitleConditionalStyle(props.GrupoContas, larguraOriginal < limiar)}
                                  id="nav-link"
                                  href="/gestao/financas/grupocontas/listar"
                                >
                                  Grupo de Contas
                                </NavDropdown.Item>

                                <NavDropdown.Item
                                  eventKey="1.3"
                                  style={getTitleConditionalStyle(props.Contas, larguraOriginal < limiar)}
                                  id="nav-link"
                                  href="/gestao/financas/contas/listar"
                                >
                                  Contas
                                </NavDropdown.Item>

                                <NavDropdown.Item
                                  eventKey="1.3"
                                  style={getTitleConditionalStyle(props.CentrosCusto, larguraOriginal < limiar)}
                                  id="nav-link"
                                  href="/gestao/financas/centroscusto/listar"
                                >
                                  Centros Custo
                                </NavDropdown.Item>

                                <NavDropdown.Item
                                  eventKey="1.4"
                                  style={getTitleConditionalStyle(props.InstituicaoBancaria, larguraOriginal < limiar)}
                                  id="nav-link"
                                  href="/gestao/financas/instituicaobancaria/listar"
                                >
                                  Instituições Bancárias
                                </NavDropdown.Item>


                                <NavDropdown.Item
                                  eventKey="1.4"
                                  style={getTitleConditionalStyle(props.Taxa, larguraOriginal < limiar)}
                                  id="nav-link"
                                  href="/gestao/financas/taxas/listar"
                                >
                                  Taxas e Aliquotas
                                </NavDropdown.Item>


                              </NavDropdown>


                            </NavDropdown>


                          )
                        }



                      </NavDropdown>

                    )
                  }





                  {
                    larguraOriginal < limiar && (
                      <div style={{ backgroundColor: 'black', width: '100%', height: '2px' }}>

                      </div>
                    )
                  }

                  {regra.includes("SUPER_ADMIN")
                    && (
                      <NavDropdown
                        title={
                          <div
                            className={larguraOriginal < limiar ? 'mobile' : ''}
                            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}

                          >
                            <SettingsOutlinedIcon sx={{ fontSize: 24, color: theme.text }} />
                            {larguraOriginal < limiar && (
                              <span style={{ marginLeft: '5px' }}>Configurações</span>
                            )}
                          </div>
                        }
                        id={larguraOriginal > limiar ? 'nav-dropdown' : 'nav-dropdownmobile'}
                        style={getConditionalStyle(props.TabelasAuxiliares, larguraOriginal < limiar)}
                        align={larguraOriginal < limiar ? "end" : ''}
                        className={larguraOriginal < limiar ? 'dropdown-submenu' : ''}
                      >

                        <NavDropdown.Item
                          eventKey="1.0"
                          style={getTitleConditionalStyle(props.Configuracoes, larguraOriginal < limiar)}
                          id="nav-link"
                          href="/administracao/configuracoes"
                        >Configurações
                        </NavDropdown.Item>

                        <NavDropdown.Item
                          eventKey="1.0"
                          style={getTitleConditionalStyle(props.Usuarios, larguraOriginal < limiar)}
                          id="nav-link"
                          href="/administracao/usuarios"
                        >Usuários
                        </NavDropdown.Item>

                      </NavDropdown>

                    )
                  }



                  <NavDropdown
                    title={

                      <div
                        className={larguraOriginal < limiar ? 'mobile' : ''}
                        style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                      >
                        <AccountCircleIcon sx={{ fontSize: 34, color: theme.text, marginRight: '8px' }} />
                        <span style={{ fontWeight: 'bold', fontSize: '1.1rem' }}>
                          {formatarNome(Cookies.get("nome_amigavel"))}
                        </span>
                        {larguraOriginal < limiar && (
                          <span style={{ marginLeft: '10px' }}>Minha Conta</span>
                        )}
                      </div>
                    }
                    id={larguraOriginal > limiar ? 'nav-dropdown' : 'nav-dropdownmobile'}
                    style={getConditionalStyle(props.TabelasAuxiliares, larguraOriginal < limiar)}
                    className={larguraOriginal < limiar ? 'dropdown-submenu' : ''}

                  >
                    {!isCliente && (
                    <>
                    <Tooltip
                      title={
                        <div
                          style={{
                            backgroundColor: 'white',
                            height: '30vh',
                            width: '30vw',
                            overflow: 'auto',
                            border: '2px solid black',
                            padding: '10px',
                          }}
                        >
                          <Grid
                            container
                            direction="column"
                            spacing={1} // adiciona espaçamento entre os itens
                            alignItems="flex-start" // alinhamento à esquerda
                          >
                            <Grid item>
                              <Typography><strong>💰 Limite por compra:  {new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' })
                                .format(limites?.limitecompra || 0)}</strong> </Typography>
                            </Grid>
                            <Grid item>
                              <Typography><strong>📅 Limite mensal:  {new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' })
                                .format(limites?.limitemensal || 0)}</strong> </Typography>
                            </Grid>
                            <Grid item>
                              <Typography><strong>🛒 Compras solicitadas:  {new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' })
                                .format(limites?.valorcomosolicitante || 0)}</strong> </Typography>
                            </Grid>
                            <Grid item>
                              <Typography><strong>✅ Compras autorizadas:  {new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' })
                                .format(limites?.valorcomoautorizador || 0)}</strong> </Typography>
                            </Grid>
                          </Grid>
                        </div>
                      }
                      placement="left"
                      arrow
                    >
                      <IconButton aria-label="Limites" style={{ color: theme.text, fontSize: 12 }}>
                        <HelpOutlineIcon style={{ color: 'blue' }} />
                        <span style={{ marginLeft: 5 }}>Limites</span>
                      </IconButton>
                    </Tooltip>


                    <Tooltip
                      title={
                        <div
                          style={{
                            backgroundColor: 'white',
                            height: '30vh',
                            width: '30vw',
                            overflow: 'auto',
                            border: '2px solid black',
                            padding: '10px',
                          }}
                        >
                          <Grid
                            container
                            direction="column"
                            spacing={1} // adiciona espaçamento entre os itens
                            alignItems="flex-start" // alinhamento à esquerda
                          >
                            <Grid item>
                              <Typography><strong>💰 Valor Total em Compras:  {new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' })
                                .format(descontos?.valortotalprecotacao || 0)}</strong> </Typography>
                            </Grid>
                            <Grid item>
                              <Typography><strong>💰 Valor Total em Descontos:  {new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' })
                                .format(descontos?.descontototal || 0)}</strong> </Typography>
                            </Grid>
                            <Grid item>
                              <Typography><strong>💰 Percentual:  {descontos?.percentualdesconto || 0} %</strong> </Typography>
                            </Grid>

                          </Grid>
                        </div>
                      }
                      placement="left"
                      arrow
                    >
                      <IconButton aria-label="Limites" style={{ color: theme.text, fontSize: 12 }}>
                        <HelpOutlineIcon style={{ color: 'blue' }} />
                        <span style={{ marginLeft: 5 }}>Descontos</span>
                      </IconButton>
                    </Tooltip>
                    </>
                    )}

                    <NavDropdown.Item
                      eventKey="1.0"
                      style={getConditionalStyle(props.MinhaConta, larguraOriginal < limiar)}
                      id="nav-link"
                      href="/minhaconta"
                    >Minha Conta
                    </NavDropdown.Item>

                    <NavDropdown.Item
                      eventKey="1.0"
                      style={getConditionalStyle(props.Sair, larguraOriginal < limiar)}
                      onClick={onConfirmSair}
                      id="nav-link"
                    >
                      Sair
                    </NavDropdown.Item>






                  </NavDropdown>



                  {larguraOriginal > limiar && !isCliente && (
                    <NavDropdown
                      id={larguraOriginal > limiar ? 'nav-dropdown' : 'nav-dropdownmobile'}

                      drop='start'

                      title={
                        <NotificationsIcon
                          className={tarefas.length > 0 ? "shake-bell" : ""}
                          style={{ color: tarefas.length > 0 ? "green" : theme.text }}
                          sx={{ fontSize: 24, color: tarefas.length > 0 ? 'green' : theme.text }} />
                      }


                    >
                      <div
                        style={{
                          maxHeight: "calc(100vh - 40px)", // 100vh menos 40px de margem (ajuste se precisar)
                          overflowY: "auto",
                          paddingBottom: "20px", // espaço no fundo
                        }}
                      >
                        {(loading && (tarefas === null || tarefas === []))
                          ? <span style={{ color: 'black' }}> Processando Notificações </span>
                          : tarefas.map((tarefa) => {
                            return (
                              <NavDropdown.Item
                                onClick={(ev) => handleOpenAlert(tarefa)}
                                style={{
                                  backgroundColor: theme.paper,
                                  color: theme.text,
                                  fontSize: "12px",
                                  paddingRight: 40,
                                }}
                                key={tarefa.id_tarefa}
                                eventKey={tarefa.id_tarefa}
                              >
                                <Grid
                                  item
                                  xs={12}
                                  container
                                  spacing={2}
                                  alignItems="center"
                                  style={{
                                    fontSize: "12px",
                                    marginRight: 30,
                                    marginLeft: 30,
                                  }}
                                >
                                  <Grid item xs={6}>
                                    <Typography>{tarefa.nome}</Typography>
                                  </Grid>
                                  <Grid item xs={6} container justifyContent="flex-end">
                                    <img
                                      style={{ height: "30px", marginInline: 5 }}
                                      alt="mini_icone_informacao"
                                      src={mini_icone_informacao}
                                    />
                                  </Grid>
                                </Grid>
                              </NavDropdown.Item>
                            );
                          })}
                      </div>
                    </NavDropdown>
                  )}



                  {larguraOriginal > limiar && !isCliente && (
                    <NavDropdown
                      id={larguraOriginal > limiar ? 'nav-dropdown' : 'nav-dropdownmobile'}
                      drop="start"
                      title={
                        <FolderIcon

                          sx={{ fontSize: 24, color: theme.text }}
                        />
                      }
                    >
                      <Box p={2} style={{ minWidth: 700 }}>
                        <Button
                          variant="contained"
                          color="primary"
                          startIcon={<AddCircleOutlineIcon />}
                          onClick={handleOpenModalNovoProjeto}
                          style={{ marginBottom: 20 }}
                          fullWidth
                        >
                          Novo Projeto + Proposta
                        </Button>
                        {!loading && projetos?.filter(projeto => projeto !== null).map((projeto) => (
                          <Box
                            key={projeto.id_projeto}
                            mb={2}
                            style={{
                              padding: 10,
                              border: `1px solid ${theme.border}`,
                              borderRadius: 6,
                              backgroundColor: theme.paper
                            }}
                          >
                            <Grid container direction="row" justifyContent="flex-start" alignItems="center" item xs={12} spacing={1}>

                              <Grid item>
                                <Typography style={{ textDecoration: "underline" }}>
                                  {projeto.instalacao.nome_fantasia}
                                </Typography>
                              </Grid>
                              <Grid item>
                                <Typography style={{ textDecoration: "underline" }}>
                                  {(projeto.instalacao.nome_mapa ? projeto.instalacao.nome_mapa : "") + " - " + projeto.instalacao.identificador_integrador}
                                </Typography>
                              </Grid>

                            </Grid>
                            <Box display="flex" alignItems="center" mb={1}>
                              <FolderIcon color="primary" style={{ marginRight: 6 }} />
                              <Button
                                variant="outlined"
                                size="small"
                                color="primary"
                                onClick={() => abrirProjetoB(projeto.id_projeto, projeto.instalacao?.id_instalacao)}
                                style={{ textTransform: 'none' }}
                              >


                                Projeto ID {projeto.id_projeto} -{' '}
                                {projeto.nome_projeto
                                  ? (projeto.nome_projeto.length > 50
                                    ? projeto.nome_projeto.substring(0, 50) + '...'
                                    : projeto.nome_projeto)
                                  : ''} -{' '}
                                {projeto.descricao_projeto
                                  ? (projeto.descricao_projeto.length > 50
                                    ? projeto.descricao_projeto.substring(0, 50) + '...'
                                    : projeto.descricao_projeto)
                                  : ''}
                              </Button>
                            </Box>

                            {/* Lista de propostas do projeto */}
                            {projeto.propostas?.filter(pr => pr !== null).length > 0 && (
                              <Box ml={4}>
                                {projeto.propostas
                                  .filter(proposta => proposta !== null)
                                  .map((proposta) => (
                                    <Box
                                      key={proposta.id_proposta}
                                      display="flex"
                                      alignItems="center"
                                      mb={0.5}
                                    >
                                      <DescriptionIcon color="action" style={{ marginRight: 6 }} />
                                      <Button
                                        size="small"
                                        color="secondary"
                                        variant="text"
                                        onClick={() => abrirPropostaB(projeto.id_projeto, proposta.id_proposta, projeto.instalacao.id_instalacao)}
                                        style={{ textTransform: 'none', padding: 0, minWidth: 'auto' }}
                                      >
                                        Proposta ID {proposta.id_proposta} - {proposta.descricao_proposta?.length > 100
                                          ? proposta.descricao_proposta.substring(0, 100) + '...'
                                          : proposta.descricao_proposta}
                                      </Button>
                                    </Box>
                                  ))}
                              </Box>
                            )}
                          </Box>
                        ))}
                      </Box>
                    </NavDropdown>
                  )}



                  {/* Dark Mode Toggle MOVED */}

                  {larguraOriginal > limiar && !isCliente && (
                    <NavDropdown
                      id={larguraOriginal > limiar ? 'nav-dropdown' : 'nav-dropdownmobile'}
                      drop="start"
                      title={<PhoneIcon sx={{ fontSize: 24, color: theme.text }} />}
                    >
                      <Box
                        p={1}
                        sx={{
                          width: 700,
                          maxHeight: 450,
                          overflowY: 'auto',
                          bgcolor: theme.paper,
                          color: theme.text,
                          border: `2px solid ${theme.border}`
                        }}
                      >
                        {!loading && ramais?.map((ramal) => (
                          <Box
                            key={ramal.id_equipamento}
                            mb={1}
                            sx={{
                              p: 1,
                              border: `1px solid ${theme.border}`,
                              borderRadius: 1,
                              transition: '0.2s',
                              backgroundColor: theme.bg,
                              '&:hover': {
                                backgroundColor: effectiveDarkMode ? theme.border : '#e0f0ff',
                                cursor: 'pointer'
                              }
                            }}
                            onClick={() => openModal(ramal.ramal)}
                          >
                            <Grid container alignItems="center" spacing={1}>
                              <Grid item>
                                <PersonIcon sx={{ fontSize: 18, color: '#1976d2' }} />
                              </Grid>
                              <Grid item xs={8}>
                                <Typography fontSize={13} fontWeight={600} noWrap style={{ color: theme.text }}>
                                  {ramal.nome_mapa}
                                </Typography>
                              </Grid>
                              <Grid item xs={2}>
                                <Typography fontSize={13} color="textSecondary" noWrap style={{ color: theme.textSecondary }}>
                                  {ramal.ramal}
                                </Typography>
                              </Grid>
                              <Grid item>
                                <Tooltip title="Chamar">
                                  <IconButton color="primary" size="small">
                                    <CallIcon sx={{ fontSize: 16 }} />
                                  </IconButton>
                                </Tooltip>
                              </Grid>
                            </Grid>
                          </Box>
                        ))}
                      </Box>
                    </NavDropdown>
                  )}

                  {/* Dark Mode Toggle */}
                  {larguraOriginal > limiar && (
                    <Tooltip title={effectiveDarkMode ? "Modo Claro" : "Modo Escuro"}>
                      <IconButton
                        onClick={toggleDarkMode}
                        size="small"
                        sx={{
                          ml: 1,
                          border: `1px solid ${effectiveDarkMode ? 'white' : '#1976d2'}`,
                          borderRadius: '50%',
                          p: 0.5
                        }}
                      >
                        {effectiveDarkMode ?
                          <Brightness7 sx={{ color: 'white', fontSize: 20 }} /> :
                          <Brightness4 sx={{ color: '#1976d2', fontSize: 20 }} />
                        }
                      </IconButton>
                    </Tooltip>
                  )}





                </Nav>


              </Navbar.Collapse>

            </Container>

          </Navbar>



        </Grid >
      </Grid >


      <div>

        {tarefaEmVista &&
          <Dialog
            open={alertOpen}
            onClose={handleCloseAlert}
            aria-labelledby="confirm-dialog"
            PaperProps={{
              style: {
                backgroundColor: theme.paper,
                color: theme.text,
              },
            }}
          >
            <DialogTitle id="confirm-dialog">{ }</DialogTitle>
            <DialogContent style={{ backgroundColor: theme.paper }}>
              <div >

                <Grid container spacing={2}
                  style={{ padding: 20 }}
                  justifyContent="flex-start"
                  alignItems="flex-start"
                  item xs={12} >
                  <Grid

                    item xs={6}

                  >
                    <Typography
                      variant="h5"
                    >
                      {tarefaEmVista.nome}
                    </Typography>
                  </Grid>

                  <Grid

                    item xs={6}

                  >
                    <div style={{ display: 'flex', justifyContent: 'center', margin: 0, width: '40px', height: '40px' }}>
                      <img alt={'mini_icone_informacao'} style={{ textAlign: 'center' }} src={mini_icone_informacao}></img>
                    </div>
                  </Grid>



                  <Grid

                    item xs={12}

                  >
                    <Typography
                      variant="h6"
                      component="div"
                      style={{ color: theme.text }}
                    >
                      {tarefaEmVista.descricao.split('\n').map((line, index) => {
                        const parts = line.split('\n'); // Dividindo a linha pela quebra de linha
                        return (
                          <React.Fragment key={index}>
                            <React.Fragment>
                              <a
                                href={processarLink()} // Adicione o link aqui
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ textDecoration: 'underline', color: 'blue' }}
                              >
                                {parts[0]} {/* Somente a primeira parte é o link */}
                              </a>
                              {parts[1]} {/* Mostra o restante do texto */}
                            </React.Fragment>
                            {/* Adiciona uma quebra de linha, se não for a última linha */}
                            {index !== tarefaEmVista.descricao.split('\n').length - 1 && <br />}
                          </React.Fragment>
                        );
                      })}
                    </Typography>
                  </Grid>
                  {(tarefaEmVista.ordem_servico?.solicitacao.id_solicitacao === 7 &&
                    tarefaEmVista.ordem_servico?.id_ordem_compra === 0) ||
                    (tarefaEmVista.ordem_servico?.criar_ordem === 1 && tarefaEmVista.ordem_servico?.finalizar_requerimento_itens === 1 && tarefaEmVista.ordem_servico?.id_ordem_compra === 0)

                    &&
                    <Grid
                      container
                      direction="row"
                      justifyContent="flex-start"
                      alignItems="center"
                      item xs={6}
                    >
                      <Button style={{ marginTop: 20 }}
                        variant="contained"
                        color="primary"
                        onClick={criarOCporOs}

                      >
                        Criar a Ordem de Compra
                      </Button>
                    </Grid>
                  }
                  <Grid
                    container
                    direction="row"
                    justifyContent="flex-end"
                    alignItems="center"
                    item xs={6}
                  >
                    <Button style={{ marginTop: 20 }}
                      variant="contained"
                      color="primary"
                      onClick={handleCloseAlert}

                    >
                      OK
                    </Button>
                  </Grid>

                  <Grid
                    container
                    direction="row"
                    justifyContent="flex-end"
                    alignItems="center"
                    item xs={6}
                  >
                    <Button style={{ marginTop: 20 }}
                      variant="contained"
                      color="secondary"
                      onClick={handleDescartarNotificacao}

                    >
                      Descartar Notificação
                    </Button>
                  </Grid>

                </Grid>
              </div>
            </DialogContent>

          </Dialog >
        }

      </div>


      {openBalao && (
        <Draggable>
          <Box
            sx={{
              position: "fixed",
              top: "20px",
              left: "20px",
              backgroundColor: "#fff",
              border: "2px solid #000", // Borda preta mais espessa
              borderRadius: "8px",
              boxShadow: "0 8px 16px rgba(0, 0, 0, 0.3)", // Aumenta a sombra
              padding: "16px",
              zIndex: 9999, // Garante que fique por cima de outros elementos
            }}


          >
            <Typography variant="body1" gutterBottom>
              {"Nova Ronda Virtual nº " + rondaVirtualPendente.id_ronda_virtual + " pendente"}
              <br />
              {"Localidade: " + returnDescricaoInstalacaoResumida(rondaVirtualPendente.instalacao)}
              <br />
              {"Grupo: " + rondaVirtualPendente.instalacao.grupo_cliente.nome}
            </Typography>
            <Grid
              sx={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "8px",
              }}
              item
              container
              xs={12}
            >
              {!justificativa && (
                <Button
                  variant="contained"
                  color="primary"
                  disabled={justificativa}
                  onClick={handleBalaoOk}
                  sx={{ marginRight: "8px" }}
                >
                  Assumir
                </Button>
              )}
              {!justificativa && (
                <Button variant="outlined" color="secondary" onClick={handleJustificativa}>
                  Agora não
                </Button>
              )}
              {justificativa && (
                <Grid
                  item
                  container
                  xs={12}
                  style={{ paddingTop: 2 }}
                >
                  <TextField
                    variant="standard"
                    name="justificativa"
                    label="Justificativa"
                    required
                    id="justificativa"
                    value={mensagemJustificativa}
                    onChange={(e) => setMensagemJustificativa(e.target.value)}
                    fullWidth
                    multiline
                    minRows={2}
                  />
                </Grid>
              )}
              {justificativa && (
                <Button variant="outlined" color="secondary" onClick={(e) => handleFinalizarJustificativa()}>
                  Finalizar
                </Button>
              )}

            </Grid>
          </Box>
        </Draggable>
      )}


      {openRondaVirtualEmAndamento && !location.pathname.includes('rondavirtual') && (
        <Draggable>
          <Box
            sx={{
              position: "fixed",
              top: "20px",
              left: "20px",
              backgroundColor: "#fff",
              border: "2px solid #000", // Borda preta mais espessa
              borderRadius: "8px",
              boxShadow: "0 8px 16px rgba(0, 0, 0, 0.3)", // Aumenta a sombra
              padding: "16px",
              zIndex: 9999, // Garante que fique por cima de outros elementos
            }}


          >
            <Typography variant="body1" gutterBottom>
              {"Você tem uma Ronda Virtual está em andamento!"}
              <br />
              {"Ronda Virtual nº " + rondaVirtualEmAndamento.id_ronda_virtual}
              <br />
              {"Localidade: " + returnDescricaoInstalacaoResumida(rondaVirtualEmAndamento.instalacao)}
              <br />
              {"Grupo: " + rondaVirtualEmAndamento.instalacao.grupo_cliente.nome}
            </Typography>
            <Grid
              sx={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "8px",
              }}
              item
              container
              xs={12}
            >
              <Button
                variant="contained"
                color="primary"
                onClick={(e) => handleIrParaGestaoRondaVirtual()}
                sx={{ marginRight: "8px" }}
              >
                Ir para gestão da Ronda Virtual
              </Button>
            </Grid>
          </Box>
        </Draggable>
      )}


      {/* Exibe a tela de resultados abaixo do Navbar se houver mais de 1 instalação encontrada */}
      {instalacoesEncontradas.length > 0 && (
        <div
          className={larguraOriginal < limiar ? "resultadoMobile" : "resultado"}
          style={{
            backgroundColor: theme.bg,
            color: theme.text,
            border: `2px solid ${theme.border}`,
            zIndex: 19999
          }}
        >
          <button className="fecharBotao" onClick={() => setInstalacoesEncontradas([])}>
            ✖
          </button>

          {instalacoesEncontradas.map((cliente) => (
            <Grid
              key={cliente.id_cliente} // Adiciona uma key para cada item no loop
              container
              direction="row"
              justifyContent="center"
              align="center"
              item xs={12}
              style={{ border: `1px solid ${theme.border}`, padding: 10, margin: 5, backgroundColor: theme.paper }}
            //onClick={() => handleInstalacaoSelecioanada(instalacao)} // Atualiza o estado ao clicar
            >
              {/*
              <LocalComponent
                id_instalacao={instalacao.id_instalacao}
                tipo_icone={instalacao.icone_mapa}
                nome_mapa={instalacao.nome_mapa}
                instalacao={instalacao}
              />
              */}
              <ClienteComponent
                id_cliente={cliente.id_cliente}
                cliente={cliente}
              />
            </Grid>
          ))}
        </div>
      )}


      {/*  

      {openBalaoNotificacao && tarefaEmVista !== null && (
        <Draggable>
          <Box
            sx={{
              position: "fixed",
              top: "20px",
              left: "20px",
              backgroundColor: "#fff",
              border: "2px solid #000", // Borda preta mais espessa
              borderRadius: "8px",
              boxShadow: "0 8px 16px rgba(0, 0, 0, 0.3)", // Aumenta a sombra
              padding: "16px",
              zIndex: 9999, // Garante que fique por cima de outros elementos
            }}


          >
            <Typography variant="body1" gutterBottom>
              {tarefaEmVista.nome}
            </Typography>
            <Grid
              sx={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "8px",
              }}
              item
              container
              xs={12}
            >

              <Button
                variant="contained"
                color="primary"
                onClick={(ev) => handleOpenAlert(tarefaEmVista)}
                sx={{ marginRight: "8px" }}
              >
                Mais Informações
              </Button>



            </Grid>
          </Box>
        </Draggable>
      )}



      {openBalaoOc &&
        OcPendente !== null &&
        window.location.pathname !== "/gestao/financas/lancamento/cadastrar" &&
        !window.location.pathname.includes("/gestao/administracao/ordensdecompras/editar") && (
          <Rnd
            size={{
              width: compactado ? 50 : 400,
              height: compactado ? 50 : "auto",
            }}
            minWidth={50}
            minHeight={50}
            bounds="window"
            dragHandleClassName="drag-handle"
            enableResizing={{
              bottom: !compactado,
              right: !compactado,
              bottomRight: !compactado,
            }}
            style={{
              zIndex: 9999,
              background: theme.bg,
              border: `2px solid ${theme.text}`,
              borderRadius: "8px",
              boxShadow: "0 8px 16px rgba(0, 0, 0, 0.3)",
              overflow: "hidden",
              padding: compactado ? 0 : "16px",
              display: "flex",
              flexDirection: "column",
              color: theme.text
            }}
          >
          
      <Box
        className="drag-handle"
        sx={{
          cursor: "move",
          width: "100%",
          height: compactado ? 50 : "auto",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#eee",
          fontWeight: "bold",
          padding: "4px",
          userSelect: "none",
        }}
        onClick={() => setCompactado(!compactado)}
      >
        {compactado
          ? "Ordem de Compra"
          : `Ordem de Compra ${OcPendente.idOrdemCompra}.${OcPendente.idPreCotacao} já AUTORIZADA`}
      </Box>

 
      {!compactado && (
        <Box sx={{ mt: 1 }}>
          <Typography variant="body1" gutterBottom>
            {`Descrição: ${OcPendente.descricao}`}
          </Typography>
          <Typography variant="body1" gutterBottom>
            {`Valor: ${new Intl.NumberFormat("pt-BR", {
              style: "currency",
              currency: "BRL",
            }).format(OcPendente.valorTotalPreCotacao)}`}
          </Typography>

          <Grid container spacing={2} sx={{ marginTop: "8px" }}>
            <Grid item>
              <Button
                variant="contained"
                color="success"
                onClick={() => {
                  window.location.href = `/gestao/financas/lancamento/cadastrar?idprecotacao=${OcPendente.idPreCotacao}`;
                }}
              >
                Criar Lançamento
              </Button>
            </Grid>

            <Grid item>
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  window.open(
                    `/gestao/administracao/ordensdecompras/editar/${OcPendente.idOrdemCompra}/editarcotacao/${OcPendente.idPreCotacao}`,
                    "_blank"
                  );
                }}
              >
                Verificar
              </Button>

              {OcPendente.arquivo && (
                <Tooltip title="Ordem de Compra" arrow>
                  <IconButton
                    size="small"
                    onClick={() => {
                      const link = OcPendente.arquivo.replaceAll(
                        "/home/wwgrup/ordensdecompra/",
                        "https://gruporosinetos.com/ocmidias/"
                      );
                      window.open(link, "_blank", "noopener,noreferrer");
                    }}
                  >
                    {OcPendente.arquivo.toLowerCase().endsWith(".pdf") ? (
                      <img src={miniatura_pdf} alt="pdf" style={{ width: 18, height: 18 }} />
                    ) : (
                      <img src={office} alt="office" style={{ width: 18, height: 18 }} />
                    )}
                  </IconButton>
                </Tooltip>
              )}
            </Grid>

            <Grid item>
              <Button
                variant="contained"
                color="warning"
                onClick={() => setMostrarCampoPulo(true)}
              >
                Mais tarde
              </Button>
            </Grid>
          </Grid>

          {mostrarCampoPulo && (
            <Box sx={{ marginTop: "12px" }}>
              <TextField
                fullWidth
                label="Motivo do adiamento"
                value={mensagemPulo}
                onChange={(e) => setMensagemPulo(e.target.value)}
              />
              <Button
                variant="contained"
                color="success"
                sx={{ marginTop: "8px" }}
                onClick={() => handlePulo()}
              >
                Confirmar
              </Button>
            </Box>
          )}
        </Box>
      )}
    </Rnd>
  )
}





{
  oSOC && show !== null && oSOC.id_ordem_compra === 0 && (
    <Draggable>
      <Box
        sx={{
          position: "fixed",
          top: "20px",
          left: "20px",
          backgroundColor: "#fff",
          border: "2px solid #000", // Borda preta mais espessa
          borderRadius: "8px",
          boxShadow: "0 8px 16px rgba(0, 0, 0, 0.3)", // Aumenta a sombra
          padding: "16px",
          zIndex: 9999, // Garante que fique por cima de outros elementos
        }}


      >
        <Typography variant="body1" gutterBottom>
          {"Elaborar Ordem de Compra (O.S º " + oSOC.id_ordem_servico + ")"}
        </Typography>
        <Grid
          sx={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: "8px",
          }}
          item
          container
          xs={12}
        >

          <Button
            variant="contained"
            color="primary"
            onClick={(ev) => handleOpenAlertDireto()}
            sx={{ marginRight: "8px" }}
          >
            Mais Informações
          </Button>



        </Grid>
      </Box>
    </Draggable>
  )
}



<div>

  {oSOC &&
    <Dialog
      open={alertOpen2}
      onClose={handleCloseAlert2}
      aria-labelledby="confirm-dialog"
    >
      <DialogTitle id="confirm-dialog">{ }</DialogTitle>
      <DialogContent >
        <div >

          <Grid container spacing={2}
            style={{ padding: 20 }}
            justifyContent="flex-start"
            alignItems="flex-start"
            item xs={12} >
            <Grid

              item xs={6}

            >
              <Typography
                variant="h5"
              >
                {"Elaborar Ordem de Compra (O.S nº " + oSOC.id_ordem_servico + ")"}
              </Typography>
            </Grid>

            <Grid

              item xs={6}

            >
              <div style={{ display: 'flex', justifyContent: 'center', margin: 0, width: '40px', height: '40px' }}>
                <img alt={'mini_icone_informacao'} style={{ textAlign: 'center' }} src={mini_icone_informacao}></img>
              </div>
            </Grid>



            <Grid

              item xs={12}

            >
              <Typography
                variant="h6"
                component="div"
                style={{ color: 'black' }}
              >
                {oSOC.descricao_solicitacao.split('\n').map((line, index) => {
                  const parts = line.split('\n'); // Dividindo a linha pela quebra de linha
                  return (
                    <React.Fragment key={index}>
                      <React.Fragment>
                        <a
                          href={processarLink2()} // Adicione o link aqui
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ textDecoration: 'underline', color: 'blue' }}
                        >
                          {parts[0]} 
    </a>
                        { parts[1] } 
                      </React.Fragment >
{ index !== oSOC.descricao_solicitacao.split('\n').length - 1 && <br /> }
                    </React.Fragment >
                  );
                })}
              </Typography >
            </Grid >
  {(
    (oSOC?.finalizar_requerimento_itens === 1 &&
      oSOC?.id_ordem_compra === 0))
  &&
  (<Grid
    container
    direction="row"
    justifyContent="flex-start"
    alignItems="center"
    item xs={6}
  >
    <Button style={{ marginTop: 20 }}
      variant="contained"
      color="primary"
      onClick={criarOCporOs2}

    >
      Criar a Ordem de Compra
    </Button>
  </Grid>
  )
            }
<Grid
  container
  direction="row"
  justifyContent="flex-end"
  alignItems="center"
  item xs={6}
>
  <Button style={{ marginTop: 20 }}
    variant="contained"
    color="primary"
    onClick={handleCloseAlert2}

  >
    OK
  </Button>
</Grid>


          </Grid >
        </div >
      </DialogContent >

    </Dialog >
  }

</div >



{
  openBalaoTarefas &&
  dadosTarefas !== null &&
  dadosTarefas.abertasParaExecutar !== null && (
    <Rnd
      default={{
        x: posicao.x,
        y: posicao.y,
      }}
      size={size}
      bounds="window"
      dragHandleClassName="drag-handle-tarefas"
      enableResizing={{
        bottom: !compactadoTarefas,
        right: !compactadoTarefas,
        bottomRight: !compactadoTarefas,
      }}
      onResizeStop={(e, direction, ref) => {
        setSize({
          width: ref.style.width,
          height: ref.style.height,
        });
      }}
      onDragStop={(e, d) => {
        setPosicao({ x: d.x, y: d.y });
        Cookies.set("pos_x_tarefas", d.x);
        Cookies.set("pos_y_tarefas", d.y);
      }}
      style={{
        zIndex: 9999,
        background: theme.bg,
        border: `2px solid ${theme.text}`,
        borderRadius: "8px",
        boxShadow: "0 8px 16px rgba(0, 0, 0, 0.3)",
        overflow: "hidden",
        padding: compactadoTarefas ? 0 : "16px",
        display: "flex",
        flexDirection: "column",
        color: theme.text
      }}
    >



      <Box
        className="drag-handle-tarefas"
        sx={{
          cursor: "move",
          width: "100%",
          height: compactadoTarefas ? 50 : "auto",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#eee",
          fontWeight: "bold",
          padding: "4px",
          userSelect: "none",
        }}
        onClick={() => {
          const novo = !compactadoTarefas;
          setCompactadoTarefas(novo);

          // Atualiza tamanho ao expandir/compactar
          setSize({
            width: novo ? 50 : 350,
            height: novo ? 50 : "auto",
          });
        }}
      >
        {compactadoTarefas
          ? `${dadosTarefas.tarefasAbertasParaExecutar} tarefas`
          : `Você possui ${dadosTarefas.tarefasAbertasParaExecutar} tarefas abertas`}
      </Box>



      {!compactadoTarefas && (
        <Box sx={{ mt: 1 }}>
          <Typography variant="body1" gutterBottom>
            Abertas para executar:{" "}
            <strong style={{ color: "red" }}>
              {dadosTarefas.tarefasAbertasParaExecutar}
            </strong>
          </Typography>

          <Button
            variant="contained"
            color="primary"
            sx={{ mt: 2 }}
            onClick={() => {
              window.location.href =
                "/gestao/administracao/ordensdeservicos/listar?menu=11";
            }}
          >
            Ver tarefas
          </Button>
        </Box>
      )}
    </Rnd>
  )
}

<div>
  <Modal
    isOpen={isOpen}
    onRequestClose={closeModal}
    style={larguraOriginal < limiar ? customStylesMobile : customStyles}
    contentLabel="Janela Modal"
    shouldCloseOnOverlayClick={false}
  >
    <button onClick={closeModal} style={{ float: "center" }}>
      Fechar
    </button>
    <iframe
      ref={iframeRef}
      onLoad={checkIframeContent}
      src={urlChamada}
      style={{
        width: "100%",
        height: "100%",
        border: "none",
      }}
      title="Softphone"
    ></iframe>
  </Modal>
</div>
  */}
      {/* MODAL NOVO PROJETO + PROPOSTA */}
      <Dialog
        open={openModalNovoProjeto}
        onClose={handleCloseModalNovoProjeto}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle style={{ backgroundColor: theme.primary, color: 'white', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span>Novo Projeto e Proposta</span>
          <IconButton onClick={handleCloseModalNovoProjeto} style={{ color: 'white' }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          {loadingModalProjetos && <Skeleton variant="rect" height={200} />}
          {!loadingModalProjetos && (
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={isNovoCliente}
                      onChange={(e) => setIsNovoCliente(e.target.checked)}
                      color="primary"
                    />
                  }
                  label="Cadastrar Novo Cliente?"
                />
              </Grid>

              {isNovoCliente ? (
                <React.Fragment>
                  <Grid item xs={12} sm={4}>
                    <FormControl fullWidth>
                      <InputLabel>Tipo de Pessoa</InputLabel>
                      <Select
                        value={tipoPessoaModal}
                        onChange={(e) => setTipoPessoaModal(e.target.value)}
                      >
                        <MenuItem value={0}>Pessoa Física</MenuItem>
                        <MenuItem value={1}>Pessoa Jurídica</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={8}>
                    <TextField
                      fullWidth
                      label={tipoPessoaModal === 0 ? "CPF" : "CNPJ"}
                      value={cnpjCpfModal}
                      onChange={(e) => tipoPessoaModal === 1 ? handleCnpjModal(e.target.value) : setCnpjCpfModal(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label={tipoPessoaModal === 0 ? "Nome" : "Razão Social"}
                      value={nomeRazaoModal}
                      onChange={(e) => setNomeRazaoModal(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label={tipoPessoaModal === 0 ? "Sobrenome" : "Nome Fantasia"}
                      value={sobrenomeFantasiaModal}
                      onChange={(e) => setSobrenomeFantasiaModal(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Email"
                      value={emailClienteModal}
                      onChange={(e) => setEmailClienteModal(e.target.value)}
                    />
                  </Grid>
                  
                  {/* Endereço */}
                  <Grid item xs={12}><Typography variant="subtitle1">Endereço da Instalação</Typography></Grid>
                  <Grid item xs={12} sm={3}>
                    <TextField
                      fullWidth
                      label="CEP"
                      value={enderecoModal.cep}
                      onChange={(e) => setEnderecoModal({...enderecoModal, cep: e.target.value})}
                    />
                  </Grid>
                  <Grid item xs={12} sm={7}>
                    <TextField
                      fullWidth
                      label="Logradouro"
                      value={enderecoModal.logradouro}
                      onChange={(e) => setEnderecoModal({...enderecoModal, logradouro: e.target.value})}
                    />
                  </Grid>
                  <Grid item xs={12} sm={2}>
                    <TextField
                      fullWidth
                      label="Nº"
                      value={enderecoModal.numero}
                      onChange={(e) => setEnderecoModal({...enderecoModal, numero: e.target.value})}
                    />
                  </Grid>
                  <Grid item xs={12} sm={5}>
                    <TextField
                      fullWidth
                      label="Bairro"
                      value={enderecoModal.bairro}
                      onChange={(e) => setEnderecoModal({...enderecoModal, bairro: e.target.value})}
                    />
                  </Grid>
                  <Grid item xs={12} sm={5}>
                    <TextField
                      fullWidth
                      label="Cidade"
                      value={enderecoModal.cidade}
                      onChange={(e) => setEnderecoModal({...enderecoModal, cidade: e.target.value})}
                    />
                  </Grid>
                  <Grid item xs={12} sm={2}>
                    <FormControl fullWidth>
                      <InputLabel>UF</InputLabel>
                      <Select
                        value={enderecoModal.estado}
                        onChange={(e) => setEnderecoModal({...enderecoModal, estado: e.target.value})}
                      >
                        {estadosBrasil.map(uf => <MenuItem key={uf} value={uf}>{uf}</MenuItem>)}
                      </Select>
                    </FormControl>
                  </Grid>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <Grid item xs={12} sm={6}>
                    <Autocomplete
                      options={listaClientesModal}
                      getOptionLabel={(option) => `ID: ${option.id_cliente} - ${option.nome || option.nome_fantasia || ''} (${option.cpf || option.cnpj || ''})`}
                      value={clienteSelecionadoModal}
                      onChange={(e, v) => {
                        setClienteSelecionadoModal(v);
                        setInstalacaoSelecionadaModal(null);
                      }}
                      renderInput={(params) => <TextField {...params} label="Selecionar Cliente" variant="outlined" />}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Autocomplete
                      options={clienteSelecionadoModal?.instalacoes || []}
                      getOptionLabel={(option) => `${option.identificador_integrador} - ${option.nome_fantasia || option.nome || ''}`}
                      value={instalacaoSelecionadaModal}
                      onChange={(e, v) => setInstalacaoSelecionadaModal(v)}
                      renderInput={(params) => <TextField {...params} label="Selecionar Instalação" variant="outlined" />}
                      disabled={!clienteSelecionadoModal}
                    />
                  </Grid>
                </React.Fragment>
              )}

              <Grid item xs={12}><hr /></Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Nome do Projeto"
                  value={nomeProjetoModal}
                  onChange={(e) => setNomeProjetoModal(e.target.value)}
                  placeholder="Ex: Projeto Residencial Silva"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  multiline
                  rows={2}
                  label="Descrição do Projeto"
                  value={descricaoProjetoModal}
                  onChange={(e) => setDescricaoProjetoModal(e.target.value)}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  multiline
                  rows={2}
                  label="Descrição da Primeira Proposta"
                  value={descricaoPropostaModal}
                  onChange={(e) => setDescricaoPropostaModal(e.target.value)}
                  placeholder="Ex: Orçamento inicial para CFTV e Alarme"
                />
              </Grid>
            </Grid>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModalNovoProjeto} color="secondary">Cancelar</Button>
          <Button 
            onClick={handleSalvarNovoProjetoRapido} 
            color="primary" 
            variant="contained"
            disabled={loadingModalProjetos || (!isNovoCliente && !instalacaoSelecionadaModal) || !nomeProjetoModal}
          >
            {loadingModalProjetos ? "Salvando..." : "Criar Projeto e Proposta"}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}
export default NavegadorGestao;